{
  "app": {
    "shellTitle": "TMM Product Admin · Platform Console",
    "loading": "Loading",
    "name": "TMM Product Admin"
  },
  "common": {
    "retry": "Retry",
    "close": "Close",
    "menu": "Menu",
    "loading": "Loading",
    "loadingPage": "Loading…",
    "language": "Language",
    "noProgress": "No progress",
    "days_one": "{{count, number}} day",
    "days_other": "{{count, number}} days",
    "unlimited": "∞",
    "panelError": "This section couldn't be shown.",
    "tryAgain": "Try again",
    "outcomeUnknown": "We couldn't confirm the change. The screen has been reloaded — check before trying again.",
    "cancel": "Cancel",
    "scope": {
      "period": "{{period}} ({{from}} – {{to}}) · {{reseller}}"
    },
    "loadedAt": "Loaded at {{time}}",
    "reload": "Reload",
    "confirm": "Confirm"
  },
  "components": {
    "saving": "Saving…",
    "cannotClear": "This can't be cleared yet. Enter a value, or leave it as it was.",
    "copy": "Copy {{identifier}}",
    "copied": "Copied",
    "lastAttemptFailed": "The last attempt failed.",
    "copyDetails": "Copy details for support",
    "idLabel": "ID {{id}}",
    "reference": "Reference: {{id}}",
    "loadFailed": "This could not be loaded.",
    "clearFilters": "Clear filters",
    "filteredEmpty": "A filter is on. Clear it to see everything.",
    "moreActions": "More actions",
    "actionsFor": "Actions for {{name}}",
    "editDetails": {
      "menu": "Edit details…",
      "title": "Edit details",
      "saved": "Details saved.",
      "refreshFailed": "Saved. Couldn't refresh",
      "nameTaken": "That name is already in use.",
      "immutable": "{{fields}} can't be changed on a live {{entity}}. Use Copy to change.",
      "conflict": "Someone else changed this. Reload to see their changes.",
      "reload": "Reload",
      "save": "Save",
      "futureOffers": "Applies to future offers only.",
      "required": "Required.",
      "tooLong": "At most {{max, number}} characters.",
      "entity": {
        "commissionPlan": "commission plan",
        "agreement": "agreement",
        "addon": "add-on",
        "reseller": "reseller"
      },
      "saveError": "Couldn't save the details."
    },
    "breadcrumbs": "Breadcrumb",
    "copyFailed": "Couldn't copy — select the text instead.",
    "unsaved": {
      "title": "Leave without saving?",
      "consequence": "Your changes to {{name}} will be lost.",
      "leave": "Leave",
      "stay": "Stay"
    },
    "errorSummary_one": "{{count, number}} field needs attention",
    "errorSummary_other": "{{count, number}} fields need attention"
  },
  "lang": {
    "en": "EN",
    "es": "ES",
    "fr": "FR",
    "pt": "PT"
  },
  "nav": {
    "signOut": "Sign out",
    "dashboard": "Dashboard",
    "group": {
      "platform": "Platform",
      "pricing": "Pricing",
      "money": "Money"
    },
    "rateCards": "Rate cards",
    "addOns": "Add-on catalog",
    "revenue": "Revenue",
    "payouts": "Payouts",
    "aiModelPrices": "AI model prices",
    "settings": "Settings",
    "partners": "Partners",
    "tickets": "Support",
    "parkedPayments": "Parked payments",
    "billingAttention": "Billing attention",
    "aiCostReconciliation": "AI cost reconciliation",
    "merchantKnowledge": "Merchant knowledge"
  },
  "shell": {
    "scope": "Platform — all tenants",
    "accountMenu": "Account",
    "collapseNav": "Collapse navigation",
    "expandNav": "Expand navigation",
    "theme": {
      "label": "Theme",
      "light": "Light",
      "dark": "Dark",
      "system": "System"
    },
    "skipToMain": "Skip to main content"
  },
  "palette": {
    "trigger": "Search or jump to…",
    "triggerLabel": "Search or jump to… ({{shortcut}})",
    "keysHint": "↑↓ to move · Enter to open · Esc to close",
    "resultCount_one": "{{count, number}} result",
    "resultCount_other": "{{count, number}} results",
    "noMatches": "No matches for \"{{q}}\"",
    "recentGone": "That record no longer exists.",
    "group": {
      "recent": "Recently viewed",
      "commands": "Commands",
      "screens": "Screens",
      "nextSteps": "Next steps"
    },
    "command": {
      "newRateCard": "New rate card",
      "theme": "Theme: {{mode}}"
    },
    "type": {
      "affiliate": "Affiliate"
    },
    "failed": {},
    "searching": {}
  },
  "page": {
    "dashboard": {
      "title": "Dashboard",
      "subtitle": "Every tenant on the platform, what they collected and what we keep."
    },
    "rateCards": {
      "title": "Rate cards"
    },
    "addOns": {
      "title": "Add-on catalog",
      "subtitle": "What the platform sells to tenants, and who has it."
    },
    "revenue": {
      "title": "Revenue",
      "subtitle": "What the fleet collected, our wholesale price, and each reseller's margin and net."
    },
    "payouts": {
      "title": "Payouts",
      "subtitle": "One run sheet for resellers and affiliates across every tenant."
    },
    "aiModelPrices": {
      "title": "AI model prices",
      "subtitle": "What the models cost us, and the platform's own AI limits."
    },
    "settings": {
      "subtitle": "Platform-wide settings for this product.",
      "title": "Product settings"
    },
    "partners": {
      "title": "Partners"
    },
    "billingAttention": {
      "title": "Billing attention",
      "subtitle": "Billing problems that need a look. Each tab is one kind."
    },
    "parkedEvents": {
      "title": "Parked payment events",
      "subtitle": "Payment events tmm-api couldn't apply. Re-apply one once the cause is fixed, or dismiss it."
    },
    "aiReconciliation": {
      "title": "AI cost reconciliation",
      "subtitle": "One row per UTC day and currency. The highlighted counts must be zero."
    },
    "resellers": {},
    "tickets": {
      "title": "Support"
    },
    "merchantKnowledge": {
      "title": "Merchant knowledge"
    }
  },
  "bootstrap": {
    "error": "Could not load application configuration.",
    "errorNotRegistered": "This host is not registered. Contact your administrator.",
    "retry": "Retry"
  },
  "auth": {
    "redirecting": "Redirecting to sign in…",
    "returning": "Completing sign-in…",
    "noAccessTitle": "You don't have access to this console",
    "noAccessBody": "Your account is signed in but has not been granted access to this product admin console. Contact your administrator if you believe this is a mistake.",
    "productAdminRequired": "Product admin access required",
    "productAdminRequiredBody": "You're signed in, but your account hasn't been granted access to this product admin console.",
    "signedOutTitle": "You're signed out",
    "signedOutBody": "Your product-admin session has ended.",
    "signInAgain": "Sign in again"
  },
  "errors": {
    "generic": "Something went wrong. Please try again.",
    "notFoundTitle": "Not found",
    "notFoundBody": "We couldn't find what you were looking for.",
    "field": {
      "rejected": "This value isn't accepted. Check it and try again."
    },
    "code": {
      "SESSION_EXPIRED": "Your session has expired. Sign in again.",
      "CSRF_VALIDATION_FAILED": "The request couldn't be verified. Reload the page and try again.",
      "INVALID_CREDENTIALS": "Those sign-in details weren't accepted.",
      "CODE_INVALID": "That sign-in link is no longer valid. Sign in again.",
      "INVALID_RETURN_URL": "That return address isn't allowed.",
      "PRODUCT_ADMIN_REQUIRED": "You don't have access to this console.",
      "PRODUCT_ADMIN_REVOKED": "Your access to this console was removed. Sign in again.",
      "PRODUCT_CONTEXT_MISMATCH": "This session belongs to a different product. Sign in again.",
      "ACTING_USER_NOT_PRODUCT_ADMIN": "Your access to this console was removed. Sign in again.",
      "TENANT_ORIGIN_MISMATCH": "That request came from an address that isn't allowed.",
      "RATE_LIMIT_REJECTED": "Too many requests. Wait a moment, then try again.",
      "RATE_LIMITED": "Too many requests. Wait a moment, then try again.",
      "INVALID_LOCALE": "That language isn't supported.",
      "NETWORK_ERROR": "Couldn't reach the server. Check your connection and try again.",
      "VALIDATION_FAILED": "Some values weren't accepted. Check them and try again.",
      "SAAS_AUTH_OUTCOME_UNKNOWN": "We couldn't confirm the change. Check before trying again.",
      "CONCURRENT_UPDATE": "Someone else changed this at the same time. Reload and try again.",
      "TENANT_CURRENCY_NOT_PRICED": "This tenant's currency isn't priced by its reseller's rate card.",
      "PRODUCT_HAS_NO_DEFAULT_BRAND": "The product has no default brand to copy. Set one in saas-admin, then try again.",
      "HOSTNAME_ALREADY_REGISTERED": "That hostname is already registered.",
      "WHITELABEL_DOMAIN_INVALID": "That domain isn't valid. Check it and try again.",
      "RESELLER_SUSPENDED_USE_REACTIVATE": "This reseller is suspended. Use Reactivate first.",
      "RESELLER_SUSPENDED_USE_STATUS": "This partner is suspended. Lift the suspension with Reactivate on its status first, then try again.",
      "RESELLER_NOT_DEACTIVATED": "This reseller isn't deactivated.",
      "RESELLER_STANDING_CONFLICT": "This reseller's standing changed. Reload and try again.",
      "RESELLER_NOT_FOUND": "That reseller couldn't be found.",
      "RESELLER_CHARGE_NOT_FOUND": "That charge couldn't be found.",
      "COMMISSION_PLAN_NAME_TAKEN": "Another of this reseller's plans has that name.",
      "PAYOUT_ON_HOLD": "This payout can't be recorded while it's on hold.",
      "DELETION_ALREADY_REQUESTED": "A deletion is already requested for this person.",
      "DELETION_CANCELLED": "This deletion request was cancelled.",
      "DELETION_REQUEST_NOT_FOUND": "That deletion request wasn't found.",
      "PROMOTION_NOT_APPLIED": "No promotion is applied to this subscription now.",
      "PROMOTION_ALREADY_APPLIED": "This subscription already has a promotion. End it first to apply a different code.",
      "PROMOTION_NOT_REDEEMABLE": "This code can't be used now. It may be inactive, outside its dates, or used up.",
      "PLAN_MAPPING_CONFLICT": "This offer's payment plan doesn't match pay-api, so nothing was changed. Trying again won't help: ask the platform team to check the offer.",
      "PLAN_CREATE_FAILED": "pay-api couldn't create the payment plan, so nothing was changed. Try again later. If it keeps failing, ask the platform team.",
      "PAY_API_UNAVAILABLE": "pay-api isn't available right now, so nothing was changed. Try again later.",
      "BILLING_CONNECTION_CONFLICT": "This tenant already has a different billing connection in pay-api.",
      "TAX_LOCATION_REQUIRED": "A billing address is needed to calculate tax. Ask the subscriber to add one, then try again.",
      "PARKED_EVENT_STILL_REFUSED": "Still refused. Nothing was changed.",
      "PARKED_EVENT_UNAVAILABLE": "pay-api no longer has this event (events are kept 90 days, and an erased member's event can't be re-read). If it was handled at pay-api, dismiss it with a note.",
      "PARKED_EVENT_RESOLVED": "Someone already resolved this event.",
      "PARKED_EVENT_NOT_FOUND": "This event isn't parked any more.",
      "PARKED_EVENT_BUSY": "This event is busy right now. Try again in a moment.",
      "AFFILIATE_STATE": "This affiliate's status changed. Reload and try again.",
      "TENANT_SLUG_TAKEN": "That slug is already registered. Choose a different one.",
      "TENANT_SETUP_INCOMPLETE": "We couldn't confirm the tenant was fully created. Trying again is safe.",
      "TENANT_CURRENCY_LOCKED": "Locked once the tenant has subscriptions.",
      "TENANT_NOT_PRICED": "This tenant can't sell yet: its reseller has no agreement.",
      "BRAND_SLUG_GENERATION_FAILED": "Couldn't generate a name for the new brand. Try again.",
      "MERCHANT_OF_RECORD_UNSET": "Merchant of record is not set.",
      "UPSTREAM_UNAVAILABLE": "The sign-in service didn't respond. Try again.",
      "RESELLER_SUSPENDED": "That reseller is suspended and can’t receive tenants.",
      "RESELLER_DEACTIVATED": "That reseller is deactivated and can’t take tenants. Choose another.",
      "RESELLER_HAS_TENANT": "This reseller already has a tenant.",
      "RESELLER_SLUG_TAKEN": "That slug is already used by another reseller.",
      "RESELLER_REQUIRED": "Reseller is required.",
      "RESELLER_CONSOLE_NOT_CONFIGURED": "tmm has no reseller console yet, so reseller users can't be invited. The platform operator sets it up in saas-admin.",
      "RESELLER_CHARGE_NOT_RETRYABLE": "This charge can't be retried now.",
      "RATE_CARD_IMMUTABLE": "Only a draft rate card can be changed.",
      "COMMISSION_PLAN_IMMUTABLE": "This plan is no longer a draft. Copy it to change it.",
      "PAYOUT_NOT_PAYABLE": "This settlement was charged to the reseller's card; there's nothing to pay.",
      "INVITATION_ALREADY_ACCEPTED": "This invitation was already accepted. The list has been refreshed.",
      "INVITATION_ALREADY_PENDING": "An invitation is already pending for this email.",
      "ALREADY_ACTIVE_MEMBER": "This person is already an active staff member.",
      "LAST_OWNER_PROTECTED": "This would remove the tenant's last owner.",
      "ROLE_CHANGE_CROSSES_TABLES": "This role change is not allowed for this staff member.",
      "GHL_LOCATION_NOT_VERIFIED": "This token can't read that location — check the location id and the token's scopes.",
      "GHL_LOCATION_ALREADY_CLAIMED": "That location is already connected elsewhere.",
      "RESELLER_PLATFORM_OWNED": "This partner is platform-owned and can't be deactivated.",
      "RESELLER_HAS_TENANTS": "This reseller still has a tenant, so it can't be deleted.",
      "RESELLER_LAST_OWNER": "This would remove the reseller's last owner.",
      "TENANT_NOT_FOUND": "That tenant couldn't be found.",
      "ADDON_ACTIVE": "This add-on is already active for this tenant.",
      "AGREEMENT_REQUIRED": "This reseller has no agreement yet.",
      "OFFER_NOT_ACTIVE": "That offer is no longer active. Choose another.",
      "RATE_CARD_NOT_ACTIVE": "Activate or fix the card first.",
      "RATE_CARD_NAME_TAKEN": "Another of this reseller's rate cards has that name.",
      "RATE_CARD_VERSION_CONFLICT": "Someone else changed this. Reload to see their changes.",
      "CARD_ADOPTED": "This reseller uses this card. It must adopt another before this grant can be revoked.",
      "RATE_CARD_NOT_FOUND": "That rate card couldn't be found.",
      "COMMISSION_PLAN_VERSION_CONFLICT": "Someone else changed this. Reload to see their changes.",
      "RATE_CARD_INVALID": "This version doesn't pass the rate card's checks yet.",
      "NO_RATE_CARD": "This reseller hasn't adopted a rate card.",
      "PAYOUTS_MOVED_TO_LEDGER": "Payouts have moved to the partner ledger. Use the partner's Ledger instead.",
      "HOLD_ALREADY_OPEN": "A hold for cause is already open on this partner.",
      "HOLD_NOT_OPEN": "This hold is no longer open. The ledger has been reloaded.",
      "HOLD_NOT_RELEASABLE": "This hold can't be released here.",
      "HOLD_OPS_ONLY": "This hold can only be released by operations; it's queued.",
      "HOLD_NOT_VOIDABLE": "Only a hold for cause can be voided.",
      "HOLD_NOT_FOUND": "This hold couldn't be found.",
      "NOTHING_TO_VOID": "The balance isn't positive, so there is nothing to void.",
      "SETTLEMENT_IN_FLIGHT": "A payout or collection is in progress. Try again once it finishes.",
      "CONFIRMATION_REQUIRED": "The confirmation doesn't match. Type it exactly as shown.",
      "PAYEE_NOT_FOUND": "This partner isn't set up as a payee yet.",
      "PAYEE_RAIL_MISMATCH": "Manual payments can only be recorded for a partner paid manually.",
      "PAYEE_ON_HOLD": "The partner's payouts are held for cause. Release the hold first.",
      "STATEMENT_NOT_PAYABLE": "This statement can't be paid with that amount.",
      "STATEMENT_NOT_FOUND": "This statement couldn't be found.",
      "TAX_YEAR_CLOSED": "That tax year is already closed. The Operator records this payment with the filing service.",
      "IDEMPOTENCY_CONFLICT": "This was already sent with different details. Reload and check.",
      "LEDGER_CUTOVER_NOT_READY": "A readiness check is failing. Fix it, then try this step again.",
      "TICKET_NOT_FOUND": "This ticket doesn't exist.",
      "TICKET_TRANSITION_INVALID": "That status can't follow the ticket's current one.",
      "TICKET_DUPLICATE_INVALID": "That can't be marked a duplicate: it's itself, already a duplicate, or a support case.",
      "ANNOUNCEMENT_NOT_FOUND": "This announcement doesn't exist.",
      "ANNOUNCEMENT_TERM_REFUSED": "This mentions an internal term. Remove it to publish.",
      "ANNOUNCEMENT_NOT_DRAFT": "This announcement is no longer a draft, so it can't be changed. Unpublish it first.",
      "ANNOUNCEMENT_NOT_PUBLISHED": "Only a published announcement can be expired.",
      "MERCHANT_PATTERN_NOT_FOUND": "This merchant pattern no longer exists.",
      "INSTITUTION_REQUEST_NOT_FOUND": "This request no longer exists.",
      "MERCHANT_PATTERN_NOT_PROMOTABLE": "This pattern can't be approved yet. It doesn't pass every gate.",
      "MERCHANT_PATTERN_STATE": "This pattern has changed, so that can't be done.",
      "INSTITUTION_REQUEST_STATE": "This request has already been handled.",
      "INSTITUTION_EXISTS": "A bank with this name is already in the catalog."
    }
  },
  "help": {
    "ariaLabel": "Help for {{label}}"
  },
  "tenants": {
    "pagination": {
      "previous": "Previous",
      "next": "Next",
      "pageOf": "Page {{page, number}} of {{total, number}}"
    },
    "create": {
      "title": "Create tenant",
      "slugLabel": "Slug",
      "slugHelper": "Lowercase letters, numbers, hyphens — up to 63 characters.",
      "slugRequired": "Slug is required.",
      "slugInvalid": "Slug must be a valid DNS label (lowercase letters, numbers, hyphens; up to 63 characters).",
      "nameLabel": "Name",
      "nameRequired": "Name is required.",
      "nameTooLong": "Name must be 200 characters or fewer.",
      "signupModeLabel": "Signup mode",
      "submitButton": "Create",
      "submitting": "Creating…",
      "cancelButton": "Cancel",
      "errorDuplicateSlug": "That slug is already registered. Choose a different one.",
      "errorGeneric": "Could not create tenant. Please try again.",
      "resellerLabel": "Reseller",
      "currencyLabel": "Currency",
      "resellerRequired": "Reseller is required.",
      "retrySafe": "We couldn't confirm the tenant was fully created. Trying again is safe.",
      "tryAgain": "Try again",
      "hasTenant": "This reseller already has a tenant.",
      "onePerReseller": "Each reseller has one tenant.",
      "billingNotProvisioned": "The tenant was created, but its billing isn't provisioned yet: {{reason}}. Open Setup → Payments to provision it."
    },
    "signupMode": {
      "PUBLIC": "Public",
      "INVITE_ONLY": "Invite only",
      "ADMIN_CREATED_ONLY": "Admin-created only",
      "DISABLED": "Disabled"
    },
    "status": {
      "ACTIVE": "Active",
      "INACTIVE": "Inactive",
      "SUSPENDED": "Suspended"
    },
    "reseller": {
      "deactivated": "That reseller is deactivated and can’t take tenants. Choose another.",
      "suspended": "That reseller is suspended and can’t receive tenants."
    },
    "deleteNote": "To suspend or delete a tenant, ask the platform operator (saas-admin).",
    "sellable": {
      "chip": "Can't sell",
      "noReseller": {
        "label": "No reseller",
        "body": "This tenant can't sell until it belongs to a reseller."
      },
      "noAgreement": {
        "label": "No agreement",
        "body": "Its reseller has no current agreement."
      },
      "currencyNotPriced": {
        "label": "Currency not priced",
        "body": "The tenant's currency ({{currency}}) isn't the currency of its reseller's rate card."
      },
      "unknown": {
        "label": "Can't sell ({{code}})",
        "body": "Check this tenant's reseller, agreement, currency and offers."
      },
      "editTenant": "Edit tenant…",
      "noRateCard": {
        "label": "No rate card",
        "body": "This tenant can't sell until its reseller activates a rate card."
      },
      "openCustomerPrices": "Open rate card"
    },
    "notPriced": {
      "currencyMessage": "This tenant's currency ({{currency}}) isn't priced by its reseller's rate card.",
      "message": "This tenant can't sell yet: its reseller has no agreement.",
      "openAgreement": "Open {{resellerName}}'s agreement"
    },
    "edit": {
      "aiDefault": "AI on by default",
      "button": "Edit…",
      "currencyLabel": "Currency",
      "currencyLocked": "Locked once the tenant has subscriptions",
      "error": "Could not update the tenant.",
      "nameLabel": "Name",
      "nameRequired": "Name is required (at most 200 characters).",
      "save": "Save",
      "signupModeLabel": "Signup mode",
      "statusLabel": "Status",
      "suspendConfirm": "Its people can't sign in until it's reactivated.",
      "title": "Edit tenant"
    },
    "upstreamUnavailable": "The sign-in service didn't respond completely. Nothing was changed — try again.",
    "statusFilter": {},
    "resellerFilter": {}
  },
  "tenant": {
    "tab": {
      "affiliates": "Affiliates"
    },
    "section": {}
  },
  "tenantDetail": {
    "notFound": "Tenant not found.",
    "identity": {
      "loadError": "Could not load tenant identity.",
      "created": "Created {{date}}",
      "status": {}
    },
    "members": {
      "help": "Who administers this tenant.",
      "removeConfirmBody": "This removes {{email}} from this tenant's staff. Their account is not deleted.",
      "title": "Tenant administrators",
      "tableAriaLabel": "Tenant staff",
      "col": {
        "email": "Email",
        "name": "Name",
        "role": "Role",
        "status": "Status",
        "actions": "Actions"
      },
      "role": {
        "OWNER": "Owner",
        "SUPER_ADMIN": "Super Admin",
        "ADMIN": "Admin",
        "STAFF": "Staff",
        "USER": "User",
        "GUEST": "Guest"
      },
      "status": {
        "ACTIVE": "Active",
        "INVITED": "Invited",
        "DISABLED": "Disabled"
      },
      "loadError": "Could not load staff.",
      "empty": "No administrators yet.",
      "changeRoleLabel": "Role for {{email}}",
      "changeRoleError": "Could not change role. Please try again.",
      "disableLabel": "Enabled",
      "toggleStatusError": "Could not update staff status. Please try again.",
      "removeButton": "Remove",
      "removeConfirmTitle": "Remove staff?",
      "removeError": "Could not remove staff. Please try again.",
      "lastOwnerProtected": "This would remove the tenant's last owner.",
      "roleChangeCrossesTables": "This role change is not allowed for this staff member.",
      "addTitle": "Add administrator",
      "addEmailLabel": "Email",
      "addEmailRequired": "Email is required.",
      "addRoleLabel": "Role",
      "addButton": "Add",
      "addSuccessMember": "Staff added.",
      "addSuccessInvitation": "Invite sent.",
      "addErrorAlreadyActive": "This person is already an active staff member.",
      "addErrorAlreadyPending": "An invitation is already pending for this email.",
      "addError": "Could not add staff. Please try again."
    },
    "customers": {
      "title": "Customers",
      "help": "End users of this tenant. Subscription details come from the product backend in a later release.",
      "tableAriaLabel": "Tenant customers",
      "searchLabel": "Search users",
      "col": {
        "email": "Email",
        "name": "Name",
        "status": "Status"
      },
      "loadError": "Could not load customers.",
      "empty": "No customers yet.",
      "emptySearch": "No customers match your search.",
      "pagination": {
        "pageOf": "Page {{page, number}} of {{total, number}}"
      }
    },
    "invitations": {
      "title": "Invitations",
      "tableAriaLabel": "Tenant invitations",
      "col": {
        "email": "Email",
        "role": "Role",
        "status": "Status",
        "created": "Created",
        "expires": "Expires",
        "actions": "Actions"
      },
      "statusAll": "Show all",
      "status": {
        "PENDING": "Pending",
        "ACCEPTED": "Accepted",
        "REVOKED": "Removed",
        "EXPIRED": "Expired"
      },
      "loadError": "Could not load invitations.",
      "empty": "No invitations pending.",
      "emptyAll": "No invitations.",
      "resendButton": "Resend",
      "resendError": "Could not resend invitation. Please try again.",
      "revokeButton": "Revoke",
      "revokeConfirmTitle": "Revoke invitation?",
      "revokeConfirmBody": "This revokes the pending invitation to {{email}}. They will no longer be able to accept it.",
      "revokeError": "Could not revoke invitation. Please try again.",
      "alreadyAccepted": "This invitation was already accepted. The list has been refreshed.",
      "notFound": "This invitation could not be found. The list has been refreshed."
    },
    "overview": {
      "period": "Period",
      "kpi": {
        "activeSubscribers": "Active subscribers",
        "trialing": "Trialing",
        "comped": "Comped",
        "guestSeats": "Guest seats",
        "chargedSeats_one": "{{shown}} charged",
        "chargedSeats_other": "{{shown}} charged",
        "connectedAccounts": "Connected accounts",
        "retail": "Retail",
        "tenantShare": "Tenant share",
        "platformShare": "Platform share",
        "pendingPayout": "Pending payout",
        "nextClose": "next close {{date}}",
        "noData": "—"
      },
      "currency": "Currency",
      "aiDefault": "AI on by default",
      "yes": "Yes",
      "no": "No",
      "emailFromName": "Email from name",
      "emailFromAddress": "Email from address",
      "emailSupportEmail": "Support email"
    },
    "offers": {
      "tableAria": "Tenant offers",
      "aiMarkupHelp": "What the customer pays over the AI provider's cost: our markup combined with the reseller's.",
      "col": {
        "id": "Offer",
        "status": "Status",
        "retailBase": "Retail base",
        "seatBands": "Seat bands",
        "aiMarkup": "AI markup (customer total)",
        "trial": "Trial (new / guest)",
        "subscribers": "Subscribers",
        "created": "Created",
        "closed": "Closed",
        "rateCard": "Rate card"
      },
      "current": "Current",
      "empty": "No offers yet.",
      "loadError": "Could not load offers.",
      "rateCardById": "Rate card {{id}}"
    },
    "promotions": {
      "tableAria": "Tenant promotions",
      "col": {
        "code": "Code",
        "name": "Name",
        "kind": "Kind",
        "value": "Value",
        "valid": "Valid",
        "redemptions": "Redemptions",
        "status": "Status",
        "newOnly": "New subscribers only"
      },
      "kind": {
        "OFFER": "Offer",
        "TRIAL_DAYS": "Trial days",
        "PERCENT_OFF_VARIABLE": "Percent off",
        "AMOUNT_OFF_VARIABLE": "Amount off"
      },
      "status": {
        "ACTIVE": "Active",
        "PAUSED": "Paused",
        "ENDED": "Ended"
      },
      "empty": "No promotions.",
      "loadError": "Could not load promotions."
    },
    "sections": {},
    "sectionTabs": {}
  },
  "resellers": {
    "loadError": "Could not load resellers.",
    "cancel": "Cancel",
    "save": "Save",
    "statusFilter": {
      "label": "Status",
      "all": "All",
      "active": "Active",
      "suspended": "Suspended"
    },
    "col": {
      "status": "Status",
      "standing": "Standing",
      "created": "Created",
      "actions": "Actions"
    },
    "role": {
      "OWNER": "Owner",
      "ADMIN": "Admin",
      "STAFF": "Staff"
    },
    "create": {
      "title": "Create reseller",
      "slugLabel": "Slug",
      "slugHelper": "Lowercase letters, numbers, hyphens — up to 63 characters.",
      "slugRequired": "Slug is required.",
      "slugInvalid": "Slug must be a valid DNS label (lowercase letters, numbers, hyphens; up to 63 characters).",
      "slugTaken": "That slug is already used by another reseller.",
      "nameLabel": "Name",
      "nameRequired": "Name is required.",
      "nameTooLong": "Name must be 200 characters or fewer.",
      "submitButton": "Create",
      "submitting": "Creating…",
      "errorGeneric": "Could not create reseller. Please try again."
    },
    "detail": {
      "loadError": "Could not load reseller."
    },
    "tab": {
      "agreement": "Agreement"
    },
    "standing": {
      "GOOD": "Good",
      "PROBATION": "Probation",
      "DEACTIVATION_DUE": "Deactivation due",
      "DEACTIVATED": "Deactivated",
      "unknown": "Unknown ({{state}})",
      "probationWindow": "Probation window",
      "notEvaluated": "Not evaluated yet. Each month from the official launch is evaluated on the 2nd of the next month.",
      "loadError": "Could not load standing.",
      "tableAria": "Standing by month",
      "reactivated": "Reactivated {{date}}. The minimum commitment restarts from then.",
      "saasAuthStatus": "saas-auth status",
      "saasAuthActive": "Active",
      "saasAuthSuspended": "Suspended",
      "saasAuthCaption": "As tmm-api last saw it.",
      "col": {
        "month": "Month",
        "minimum": "Minimum",
        "earned": "Earned",
        "shortfall": "Shortfall",
        "shortfallCharge": "Shortfall charge"
      },
      "officialLaunch": "Official launch",
      "launchNotSet": "Not set — no month is evaluated until the agreement sets one.",
      "launchNoneSet": "No official launch is set.",
      "openAgreement": "Open the Agreement tab",
      "probationDeadline": "Probation deadline",
      "judgedOn": "Judged on {{date}}",
      "nextNotice": "Next notice",
      "noNotice": "None scheduled",
      "notEvaluatedNoLaunch": "Not evaluated: there is no official launch yet.",
      "viewCharge": "View charge",
      "viewChargeAria": "View charge for {{month}}",
      "endProbation": {
        "button": "End probation…",
        "title": "End probation for {{name}}?",
        "body": "Ends probation now. The reseller is emailed that it has recovered.",
        "confirm": "End probation",
        "done": "Probation ended. The reseller is in good standing.",
        "conflict": "This reseller is no longer on probation, so there was nothing to end. The screen has been reloaded.",
        "error": "Could not end probation."
      }
    },
    "deactivate": {
      "title": "Deactivate partner",
      "confirm": "Deactivate {{from}}?",
      "submit": "Deactivate",
      "error": "Could not deactivate the partner.",
      "consequence": "Deactivating suspends this partner's administrators and makes the platform manage it. Its tenant keeps selling. Settlements are retained by the platform (nothing is paid out) until you reactivate."
    },
    "reactivate": {
      "button": "Reactivate…",
      "title": "Reactivate {{name}}?",
      "body": "Reactivating restores this partner's administrators and resumes payouts from the next settlement. Settlements already retained stay retained.",
      "reason": "Reason",
      "counter_one": "{{count, number}}/{{max, number}}",
      "counter_other": "{{count, number}}/{{max, number}}",
      "confirm": "Reactivate",
      "done": "{{name}} is active again.",
      "error": "Could not reactivate the reseller.",
      "conflict": "Reactivate was refused because this reseller's status changed. The screen has been reloaded.",
      "notDeactivated": "This partner isn't deactivated. Use Reactivate on the status toggle to lift an ordinary suspension."
    },
    "overview": {
      "updated": "Updated",
      "brand": "Brand",
      "visibility": "Visibility",
      "ownBrand": "Has its own brand",
      "productBrand": "No brand of its own — its tenants use the product brand.",
      "renameHelper": "The reseller brand follows the new name unless it was customised.",
      "suspend": "Suspend",
      "suspendTitle": "Suspend {{name}}?",
      "suspendBody": "Its users can't sign in. Its tenants keep working.",
      "reactivate": "Reactivate",
      "reactivateTitle": "Reactivate {{name}}?",
      "reactivateBody": "Its users can sign in again.",
      "statusError": "Could not change reseller status.",
      "statusStandingConflict": "This reseller is deactivated, so its status can't be changed here. Use Reactivate… to bring it back. The screen has been reloaded.",
      "delete": "Delete…",
      "deleteTitle": "Delete {{name}}?",
      "deleteBody": "This deletes the reseller and its brand. It cannot be undone.",
      "deleteConfirm": "Delete",
      "deleteError": "Could not delete reseller.",
      "deactivate": "Deactivate…",
      "deactivationDue": "This partner missed its minimum through probation. Keep it and review next month, or deactivate it so the platform manages it in place.",
      "deactivated": "This partner is deactivated. Its administrators can't sign in; its tenant keeps selling.",
      "takeoverReactivate": "This partner can be reactivated during the take-over.",
      "deactivatedButActive": "Active in saas-auth, so its users may be able to sign in. Reactivate it here, or ask the platform operator to suspend it again in saas-admin.",
      "createBrand": "Create brand",
      "brandCreated": "Brand created.",
      "brandCreateError": "Could not create the brand.",
      "brandEditedIn": "The brand is edited in saas-admin.",
      "keep": {
        "button": "Keep this reseller…",
        "title": "Keep {{name}}?",
        "body": "Clears the deactivation flag. Its shortfall charges stay open.",
        "reason": "Reason",
        "counter_one": "{{count, number}}/{{max, number}}",
        "counter_other": "{{count, number}}/{{max, number}}",
        "confirm": "Keep this reseller",
        "done": "Kept. The deactivation flag is cleared; its shortfall charges stay open.",
        "error": "Could not keep the reseller.",
        "conflict": "This reseller is no longer due for deactivation, so there was nothing to clear. The screen has been reloaded.",
        "suspended": "This reseller is suspended in saas-auth, so clearing isn't enough. Use Reactivate… instead."
      },
      "brandNoProductDefault": "The product has no default brand to copy. Set one in saas-admin, then try again.",
      "brandSlugFailed": "Couldn't generate a name for the new brand. Try again.",
      "probation": "This reseller is on probation for missing its minimum. End probation if it has recovered.",
      "details": "Details",
      "card": {
        "standing": "Standing",
        "latestSettlement": "Latest settlement",
        "none": "None",
        "loadError": "Couldn't load this.",
        "meaning": {
          "GOOD": "It is meeting its minimum.",
          "PROBATION": "It missed its minimum and is on probation.",
          "DEACTIVATION_DUE": "It missed its minimum through probation.",
          "DEACTIVATED": "Its administrators lose access; its tenant keeps selling."
        },
        "affiliateAssigned": "{{plans, number}} plans · {{affiliates, number}} affiliates assigned"
      }
    },
    "users": {
      "searchLabel": "Search users",
      "invite": "Invite administrator…",
      "inviteTitle": "Invite administrator",
      "inviteSubmit": "Send invitation",
      "emailLabel": "Email",
      "roleLabel": "Role",
      "emailRequired": "Email is required.",
      "invited": "Invitation sent.",
      "inviteError": "Could not send the invitation.",
      "noConsole": "tmm has no reseller console yet, so reseller users can't be invited. The platform operator sets it up in saas-admin.",
      "loadError": "Could not load users.",
      "tableAriaLabel": "Reseller users",
      "empty": "No users yet.",
      "col": {
        "email": "Email",
        "name": "Name",
        "role": "Role",
        "status": "Status",
        "mfa": "MFA",
        "password": "Password"
      },
      "roleFor": "Role for {{email}}",
      "roleError": "Could not change the role.",
      "mfaOn": "MFA",
      "passwordSet": "Password",
      "suspend": "Suspend",
      "reactivate": "Reactivate",
      "statusError": "Could not change the status.",
      "remove": "Remove",
      "removeTitle": "Remove user?",
      "removeBody": "This removes {{email}} from this reseller, with its password and sessions.",
      "removeError": "Could not remove the user."
    },
    "invitations": {
      "tableAriaLabel": "Reseller invitations"
    },
    "ghl": {
      "title": "GHL connection",
      "notConnected": "Not connected",
      "connect": "Connect…",
      "connectTitle": "Connect GHL",
      "edit": "Edit…",
      "editTitle": "Edit GHL connection",
      "disconnect": "Disconnect…",
      "disconnectTitle": "Disconnect GHL?",
      "disconnectBody": "This deletes the reseller’s GHL connection and its stored token.",
      "disconnectConfirm": "Disconnect",
      "disconnected": "Disconnected.",
      "disconnectError": "Could not disconnect.",
      "loadError": "Could not load the GHL connection.",
      "locationId": "Location id",
      "locationClaimed": "That location is already connected elsewhere.",
      "locationRule": "1–64 letters, digits, '_' or '-'. Leave blank for no location.",
      "locationNotVerified": "This token can't read that location — check the location id and the token's scopes.",
      "token": "Private integration token",
      "tokenNotSet": "Not set",
      "tokenHelper": "Leave blank to keep the current token",
      "active": "Active",
      "yes": "Yes",
      "no": "No",
      "saved": "GHL connection saved.",
      "saveError": "Could not save the connection.",
      "diagnose": {
        "button": "Diagnose",
        "running": "Running the diagnosis",
        "wait": "Checking GHL — this can take a few seconds.",
        "error": "Could not run the diagnosis.",
        "title": "Diagnosis",
        "unknown": "GoHighLevel returned a result this console doesn't recognise.",
        "copyDetails": "Copy details for support",
        "interpretation": {
          "HEALTHY": "Healthy",
          "LIKELY_MISSING_SCOPE": "Missing permission",
          "LIKELY_CREDENTIAL_CORRUPT": "Token damaged",
          "LIKELY_CREDENTIAL_INVALID": "Token rejected",
          "UPSTREAM_UNAVAILABLE": "GHL unavailable",
          "INDETERMINATE": "No clear pattern"
        },
        "hint": {
          "HEALTHY": "Both checks passed.",
          "LIKELY_MISSING_SCOPE": "The token is missing a permission GHL needs.",
          "LIKELY_CREDENTIAL_CORRUPT": "The stored token looks damaged — set it again.",
          "LIKELY_CREDENTIAL_INVALID": "GHL rejected the token — replace it.",
          "UPSTREAM_UNAVAILABLE": "GHL didn’t answer — try again later.",
          "INDETERMINATE": "The checks didn’t match a known pattern — see the results below."
        },
        "contacts": "Contacts",
        "customFields": "Custom fields",
        "check": "Check",
        "result": "Result",
        "ok": "OK",
        "failed": "Failed"
      },
      "saveWait": "Checking the token with GHL — this can take up to 30 seconds.",
      "connectionName": "the GHL connection"
    },
    "agreement": {
      "dialog": {
        "takesEffectNow": "It takes effect now.",
        "confirm": "Starting a new version ends the current agreement and re-prices every tenant of {{reseller}}. Subscribers keep the offer they bought.",
        "confirmSubmit": "Start version",
        "connectTenant": "Connect tenant",
        "createTitle": "Create agreement",
        "minPayout": "Minimum payout",
        "monthlyMinimum": "Monthly minimum",
        "newTitle": "New agreement version",
        "notes": "Notes",
        "probation": "Probation months",
        "officialLaunch": "Official launch",
        "launchSetHelp": "Can't be removed once set. You can move it to another month.",
        "launchUnsetHelp": "The 1st of the chosen month. No month is evaluated until one is set.",
        "launchKeep": "{{month}} (current)",
        "launchNotSet": "Not set",
        "launchConfirm": "The official launch becomes {{month}}. It can't be removed once set.",
        "currency": "Currency"
      },
      "by": "By",
      "cadence": {
        "MONTHLY": "Monthly",
        "WEEKLY": "Weekly"
      },
      "cadenceLabel": "Payout cadence",
      "col": {
        "cadence": "Cadence",
        "effectiveFrom": "Effective from",
        "ended": "Ended",
        "method": "Method",
        "monthlyMin": "Monthly minimum",
        "officialLaunch": "Official launch",
        "currency": "Currency"
      },
      "connectTenant": "Connect tenant",
      "create": "Create agreement…",
      "current": "Current agreement",
      "effectiveFrom": "Effective from",
      "error": "Could not start the agreement.",
      "history": "History",
      "historyAria": "Agreement history",
      "historyEmpty": "No previous versions.",
      "loadError": "Could not load the agreement.",
      "methodLabel": "Payout method",
      "minPayout": "Minimum payout",
      "monthlyMinimum": "Monthly minimum",
      "newVersion": "New version…",
      "none": "No agreement. This reseller's tenants can't sell until one exists.",
      "notes": "Notes",
      "payoutAccount": "Payout account",
      "probation": "Probation months",
      "probationHint": "A month below the minimum opens probation; tmm flags the reseller for deactivation if it doesn't recover.",
      "probationInvalid": "Must be zero or greater.",
      "taxDocs": {
        "COLLECTED": "Collected",
        "NOT_REQUIRED": "Not required",
        "PENDING": "Pending"
      },
      "taxDocsLabel": "Tax documents",
      "taxIdLabel": "Tax ID",
      "taxIdCurrent": "Partner's tax ID at pay-api",
      "taxId": {
        "MISMATCH": "Mismatch",
        "NOT_REQUIRED": "Not required",
        "PENDING": "Pending",
        "VERIFIED": "Verified"
      },
      "officialLaunch": "Official launch",
      "launchNotSet": "Not set",
      "launchNotSetLong": "Not set — no month is evaluated until one is set.",
      "page": {
        "startVersion": "Start new version",
        "create": "Create agreement"
      },
      "section": {
        "pricing": "Pricing and launch",
        "payouts": "Payouts",
        "minimum": "Monthly minimum"
      },
      "preview": {
        "minPayout": "Paid out when at least {{amount}}",
        "monthlyMinimum": "At least {{amount}} per month"
      },
      "started": "Agreement version started for {{reseller}}.",
      "currencyHelp": "Defaults to the adopted card's currency.",
      "versionFrom": "Agreement from {{date}}",
      "currency": "Currency",
      "currencyNotChosen": "Not chosen",
      "currencyNoAdoption": "This reseller hasn't adopted a rate card, so choose the currency."
    },
    "settlements": {
      "filter": {
        "currency": "Currency",
        "allCurrencies": "All",
        "from": "From",
        "to": "To",
        "status": "Status",
        "allStatuses": "All"
      },
      "loadError": "Could not load settlements.",
      "tableAria": "Settlements",
      "col": {
        "month": "Month",
        "currency": "Currency",
        "margin": "Margin",
        "affiliates": "Affiliates",
        "net": "Net",
        "outcome": "Outcome",
        "actions": "Actions"
      },
      "empty": "No settlements.",
      "emptyBody": "Each month closes on the 2nd of the next month, one settlement per currency.",
      "expand": "Expand {{month}}",
      "collapse": "Collapse {{month}}",
      "recordAria": "Record payout… for {{month}} {{currency}}",
      "outcome": {
        "PAID": "Paid {{date}}",
        "PENDING": "To pay",
        "CARRIED": "Carried (under minimum)",
        "CHARGED": "Charged to card",
        "RETAINED": "Retained"
      },
      "viewChargeAria": "View charge for {{month}} {{currency}}",
      "byLineAria": "Settlement by line",
      "byLine": {
        "line": "Line",
        "retail": "Retail",
        "wholesale": "Wholesale",
        "margin": "Margin",
        "affiliates": "Affiliates",
        "aiAtOurPrice": "AI at our price"
      },
      "events": {
        "aria": "Affiliate bounties and milestones",
        "line": "Line",
        "amount": "Amount",
        "bounties": "Affiliate bounties",
        "milestones": "Affiliate milestones",
        "recovered": "Recovered clawbacks"
      },
      "retainedTooltip": "Kept by the platform while it manages this partner; nothing is paid out.",
      "retainedPart": "Retained {{amount}}",
      "normalPart": "Payable {{amount}}"
    },
    "notices": {
      "sent": "Notices sent",
      "filter": {
        "kind": "Kind",
        "allKinds": "All kinds"
      },
      "tableAria": "Notices",
      "col": {
        "when": "Sent / created",
        "kind": "Kind",
        "period": "Period",
        "status": "Status",
        "recipients": "Recipients"
      },
      "loadError": "Could not load notices.",
      "empty": "No notices yet.",
      "emptyFiltered": "No notices match this filter.",
      "expand": "Expand {{kind}}, {{period}}",
      "collapse": "Collapse {{kind}}, {{period}}",
      "created": "Created, not sent",
      "recipients": "{{n, number}} recipients",
      "factsAria": "Facts: {{kind}}, {{period}}",
      "chargesAria": "Charges in this notice",
      "kind": {
        "LAUNCH_REMINDER": "Launch reminder",
        "PROBATION_STARTED": "Probation started",
        "PROBATION_MONTHLY": "Probation update",
        "CHARGE_FAILED": "Charge failed",
        "CHARGE_ACTION_REQUIRED": "Charge needs action",
        "DEACTIVATED": "Deactivated",
        "RECOVERED": "Recovered"
      },
      "status": {
        "PENDING": "Pending",
        "SENDING": "Sending",
        "SENT": "Sent",
        "SKIPPED": "Skipped",
        "FAILED": "Failed"
      },
      "statusHint": {
        "PENDING": "Not sent yet. The notice engine sends it within the hour.",
        "SKIPPED": "Not sent: mail not configured, no recipient, or no longer needed"
      },
      "fact": {
        "month": "Month",
        "currency": "Currency",
        "shortfall": "Shortfall",
        "probationMonths": "Probation months",
        "target": "Minimum for the probation window",
        "earned": "Earned so far",
        "stillNeeded": "Still needed",
        "deactivationOn": "Deactivation date",
        "launchOn": "Official launch",
        "toReseller": "Tenants moved to",
        "tenantsMoved": "Tenants moved"
      },
      "charge": {
        "kind": "Charge",
        "amount": "Amount",
        "status": "Status",
        "holdOn": "Holds payouts from"
      }
    },
    "section": {},
    "sectionCaption": {},
    "actions": {}
  },
  "dashboard": {
    "tabs": {
      "aria": "Dashboard sections",
      "trends": "Trends",
      "tenants": "Tenants",
      "resellers": "Resellers"
    },
    "period": {
      "label": "Period",
      "THIS_MONTH": "This month",
      "LAST_30_DAYS": "Last 30 days",
      "LAST_MONTH": "Last month"
    },
    "loadError": "Could not load the fleet dashboard.",
    "kpi": {
      "activeSubscribers": "Active subscribers",
      "acrossTenants_one": "across {{count, number}} tenant",
      "acrossTenants_other": "across {{count, number}} tenants",
      "trialing": "Trialing",
      "newAndChurned": "{{new}} new · {{churned}} churned",
      "retailCollected": "Retail collected",
      "beforeShares": "before tenant shares",
      "platformShare": "Platform share",
      "reachedUs": "what reached us",
      "pendingPayouts": "Pending payouts",
      "paidInPeriod": "{{paid}} paid this period",
      "addonsActive": "Add-ons active",
      "connectedAccounts": "Connected accounts",
      "guestSeats": "Guests' seats",
      "tenantShare": "Tenant share",
      "uplift": "Uplift",
      "wholesale": "Wholesale"
    },
    "chart": {
      "retailTitle": "Retail by tenant",
      "subscribersTitle": "Active subscribers, daily",
      "subscribersAria": "Active subscribers, daily",
      "empty": "No activity in this period.",
      "retailAriaCurrency": "Retail by tenant in {{currency}}, {{from}} to {{to}}",
      "retailTitleCurrency": "Retail by tenant · {{currency}}"
    },
    "fleet": {
      "subtitle": "Retail is what subscribers paid. Platform is what we keep after the tenant's share.",
      "tableAria": "Fleet by tenant",
      "col": {
        "tenant": "Tenant",
        "subscribers": "Subscribers",
        "new": "New",
        "churned": "Churned",
        "retail": "Retail",
        "wholesale": "Wholesale",
        "uplift": "Uplift",
        "tenantShare": "Tenant share",
        "platform": "Platform",
        "nextClose": "Next close"
      },
      "totalsInCurrency": "Totals in {{currency}}",
      "empty": "No tenants yet."
    },
    "standing": {
      "deactivationDue_one": "{{count, number}} reseller missed its minimum through probation and is due for deactivation.",
      "deactivationDue_other": "{{count, number}} resellers missed their minimum through probation and are due for deactivation."
    },
    "byReseller": {
      "col": {
        "platform": "Platform share",
        "reseller": "Reseller",
        "retail": "Retail",
        "subscribers": "Active subscribers",
        "tenants": "Tenants"
      },
      "noReseller": "No reseller",
      "tableAria": "Fleet by reseller",
      "title": "By reseller"
    },
    "affiliateBonuses": {
      "title": "Affiliate bonuses",
      "tableAria": "Affiliate bonuses by reseller",
      "col": {
        "reseller": "Reseller",
        "currency": "Currency",
        "bounties": "Bounties",
        "milestones": "Milestones"
      }
    },
    "resellerFilter": {
      "all": "All"
    },
    "unpaidCharges": {
      "title": "Unpaid reseller charges:",
      "item_one": "{{shown}} · {{amount}}",
      "item_other": "{{shown}} · {{amount}}"
    },
    "retainedMargin": {
      "title": "Retained margin",
      "absorbed": "Absorbed by the platform."
    }
  },
  "rateCards": {
    "status": {
      "DRAFT": "Draft",
      "ACTIVE": "Active",
      "CLOSED": "Closed"
    },
    "ai": "AI",
    "actions": {
      "activate": "Activate",
      "close": "Close",
      "copy": "Copy"
    },
    "form": {
      "name": "Name",
      "currency": "Currency",
      "trialNew": "Trial days — new subscriber",
      "trialGuest": "Trial days — guest conversion",
      "nonNegative": "Must be zero or greater.",
      "section": {
        "trials": "Trials"
      }
    },
    "help": {
      "trialNew": {
        "short": "Free days before the first charge for someone subscribing directly. 0 = pays from day one."
      },
      "trialGuest": {
        "short": "Free days for a guest who becomes a subscriber."
      },
      "aiFirstPurchase": {
        "short": "What a person pays the first time they turn AI on. It enables AI."
      },
      "aiRechargeTrigger": {
        "short": "When the AI balance falls below this, the subscriber's card is charged the recharge amount."
      },
      "aiRechargeAmount": {
        "short": "What one automatic recharge charges. It's also the smallest manual top-up."
      }
    }
  },
  "subscription": {
    "status": {
      "ACTIVE": "Active",
      "TRIALING": "Trialing",
      "CANCELLED": "Cancelled",
      "ENDING": "Ending",
      "ENDED": "Ended",
      "PAST_DUE": "Past due",
      "COMPED": "Comped"
    }
  },
  "subscriptions": {
    "tabs": {
      "aria": "Subscription sections",
      "subscriptions": "Subscriptions",
      "pending": "Pending",
      "count": "{{label}} ({{count, number}})"
    },
    "tableAria": "Tenant subscriptions",
    "loadError": "Could not load subscriptions.",
    "empty": "No subscriptions.",
    "statusFilter": "Status",
    "statusAll": "All",
    "emailFilter": "Email",
    "subscribe": "Subscribe",
    "view": "View",
    "offerCurrent": "current",
    "col": {
      "email": "Email",
      "name": "Name",
      "status": "Status",
      "origin": "Origin",
      "offer": "Offer",
      "period": "Period",
      "nextBilling": "Next billing",
      "card": "Card",
      "actions": "Actions"
    },
    "origin": {
      "SELF": "Self",
      "ADMIN": "Admin",
      "COMP": "Comp"
    },
    "pending": {
      "title": "Pending admin subscriptions",
      "empty": "No pending subscriptions.",
      "email": "Email",
      "status": "Status",
      "offer": "Offer",
      "trialDays": "Trial days",
      "comp": "Comp until {{compedUntil}}",
      "compLabel": "Comp",
      "createdBy": "Created by",
      "expires": "Expires"
    },
    "pendingStatus": {
      "PENDING": "Pending",
      "COMPLETED": "Completed",
      "EXPIRED": "Expired",
      "CANCELLED": "Cancelled"
    },
    "subscribed": {
      "pending": "Invitation sent; the subscription starts when {{email}} completes sign-up.",
      "created": "Subscription created."
    },
    "subscribeDialog": {
      "title": "Subscribe",
      "email": "Email",
      "emailRequired": "Email is required.",
      "emailInvalid": "Enter a valid email.",
      "trialDays": "Trial days",
      "trialInvalid": "Must be zero or greater.",
      "comp": "Comp",
      "until": "Comp until",
      "submit": "Subscribe",
      "cancel": "Cancel"
    },
    "detail": {
      "title": "Subscription",
      "entitlements": "Entitlements",
      "statements": "Statements",
      "payApi": "pay-api",
      "noPayApi": "No pay-api record",
      "close": "Close",
      "loadError": "Couldn't load this subscription."
    },
    "entitlement": {
      "kind": "Kind",
      "status": "Status",
      "startsAt": "Starts",
      "endsAt": "Ends",
      "sponsor": "Sponsor"
    },
    "field": {
      "id": "Id",
      "userId": "User id",
      "email": "Email",
      "displayName": "Name",
      "status": "Status",
      "origin": "Origin",
      "retailOfferId": "Offer",
      "promotion": "Promotion",
      "trialEndsOn": "Trial ends",
      "compedUntil": "Comped until",
      "currentPeriodStart": "Period start",
      "currentPeriodEnd": "Period end",
      "nextBillingOn": "Next billing",
      "cardBrand": "Card brand",
      "maskedCard": "Masked card",
      "payApiSubscriptionId": "pay-api id",
      "reconciledAt": "Reconciled",
      "createdBy": "Created by",
      "createdAt": "Created",
      "updatedAt": "Updated"
    },
    "payApi": {
      "subscriptionId": "Id",
      "status": "Status",
      "planMappingId": "Plan mapping",
      "contactRef": "Contact",
      "verticalRef": "Vertical",
      "createdAt": "Created",
      "nextBillingOn": "Next billing",
      "pauseEffectiveOn": "Pause effective",
      "cardBrand": "Card brand",
      "maskedCard": "Masked card",
      "pspSubscriptionId": "PSP id"
    },
    "actions": {
      "cancel": "Cancel…",
      "changeOffer": "Change offer…",
      "comp": "Comp…",
      "applyPromotion": "Apply promotion…",
      "endPromotion": "End promotion",
      "aiSuspension": "AI suspension",
      "moveToCurrent": "Move to current version…"
    },
    "move": {
      "title": "Move to the current version?",
      "consequence": "{{subscriber}} moves to {{card}} v{{version, number}} (the current version). They're sent a notice. If they're already on it, nothing changes.",
      "confirm": "Move",
      "moved": "Moved to v{{version, number}}. A notice was sent.",
      "already": "Already on the current version. Nothing changed.",
      "failed": "The move didn't complete. Try again; it's safe to repeat.",
      "error": "Couldn't move this subscription."
    },
    "cancel": {
      "title": "Cancel subscription",
      "titleNamed": "Cancel the subscription for {{subscriber}}?",
      "mode": "Mode",
      "at_period_end": "At period end",
      "immediate": "Immediate",
      "confirm": "Cancel subscription",
      "resultStatus": "Status",
      "endsAt": "Ends at",
      "error": "Couldn't cancel the subscription.",
      "keep": "Keep subscription",
      "consequence": {
        "at_period_end": "It won't renew. The subscriber keeps access until the end of the current period.",
        "immediate": "The subscriber loses access now, and a final statement and charge may follow."
      }
    },
    "changeOffer": {
      "title": "Change offer",
      "offer": "Offer",
      "offerN": "Offer {{id}}",
      "submit": "Change",
      "none": "No offer can be chosen right now.",
      "unselectable_one": "{{count, number}} offer can't be chosen",
      "unselectable_other": "{{count, number}} offers can't be chosen",
      "reasonNotActive": "{{name}}: its rate card isn't active.",
      "closed": "{{name}}: this offer version is closed.",
      "unexplained": "{{name}} can't be chosen right now.",
      "loadError": "Could not load offers.",
      "offerInactive": "That offer is no longer active. Choose another.",
      "error": "Couldn't change the offer."
    },
    "comp": {
      "title": "Comp subscription",
      "until": "Until",
      "submit": "Comp",
      "error": "Couldn't comp the subscription."
    },
    "promotion": {
      "applyTitle": "Apply promotion",
      "code": "Code",
      "codeRequired": "Code is required.",
      "apply": "Apply",
      "endTitle": "End promotion",
      "codeName": "{{code}} · {{name}}",
      "termsPercent": "{{pct}} off usage",
      "termsAmount": "{{amount}} off usage per statement",
      "termsOffer": "Promotional offer price",
      "statementsLeft_one": "{{count, number}} statement left",
      "statementsLeft_other": "{{count, number}} statements left",
      "untilEnded": "Until ended",
      "appliedOn": "Applied {{date}}",
      "endBodyVariable": "End {{code}} for {{subscriber}}? The discount stops from the next statement. Statements already issued keep it. You can apply the code again later while it's still valid.",
      "endBodyOffer": "End {{code}} for {{subscriber}}? Their price doesn't change. This lets you apply a different code.",
      "endConfirm": "End promotion",
      "error": "Couldn't apply the promotion.",
      "endError": "Couldn't end the promotion.",
      "endKeep": "Keep promotion"
    },
    "ai": {
      "title": "AI suspension",
      "suspended": "AI suspended by the platform",
      "reason": "Reason",
      "reasonRequired": "Reason is required.",
      "confirm": "Confirm",
      "error": "Couldn't change the AI suspension."
    },
    "emailHint": "Searches email",
    "subscribeError": "Couldn't create the subscription."
  },
  "statements": {
    "tableAria": "Tenant statements",
    "copyDetailsAria": "Copy details for support for statement {{id, number}}",
    "loadError": "Could not load statements.",
    "empty": "No statements.",
    "periodFilter": "Period",
    "periodInvalid": "Use YYYY-MM.",
    "statusFilter": "Status",
    "statusAll": "All",
    "expand": "Expand lines",
    "collapse": "Collapse lines",
    "retry": "Retry",
    "waive": "Waive…",
    "col": {
      "period": "Period",
      "status": "Status",
      "renewal": "Renewal",
      "seats": "Seats",
      "tax": "Tax",
      "total": "Total",
      "attempts": "Attempts",
      "actions": "Actions"
    },
    "lines": {
      "kind": "Kind",
      "description": "Description",
      "quantity": "Quantity",
      "unit": "Unit",
      "amount": "Amount",
      "reference": "Reference"
    },
    "kind": {
      "RENEWAL": "Renewal",
      "SEAT": "Seat",
      "AI": "AI",
      "PROMOTION": "Promotion",
      "TAX": "Tax",
      "CONNECTED": "Connected accounts"
    },
    "chargeStatus": {
      "NONE": "None",
      "PENDING": "Pending",
      "PAID": "Paid",
      "ACTION_REQUIRED": "Action required",
      "FAILED": "Failed",
      "ATTENTION": "Attention",
      "WAIVED": "Waived"
    },
    "waiveDialog": {
      "title": "Waive statement",
      "reason": "Reason",
      "reasonRequired": "Reason is required.",
      "submit": "Waive"
    },
    "retryError": "Couldn't retry the statement.",
    "waiveError": "Couldn't waive the statement."
  },
  "seats": {
    "tableAria": "Tenant seats",
    "loadError": "Could not load seats.",
    "empty": "No guest seats.",
    "sponsorFilter": "Sponsor user id",
    "col": {
      "guest": "Guest",
      "sponsor": "Sponsor",
      "status": "Status",
      "since": "Since",
      "ends": "Ends"
    },
    "status": {
      "ACTIVE": "Active",
      "ENDING": "Ending",
      "ENDED": "Ended"
    }
  },
  "revenue": {
    "empty": "No revenue in this period.",
    "loadError": "Could not load revenue.",
    "tableAria": "Revenue by tenant",
    "breakdownAria": "Revenue by line kind",
    "expand": "Expand line kinds",
    "collapse": "Collapse line kinds",
    "kpi": {
      "retail": "Retail",
      "wholesale": "Wholesale (our price)",
      "tax": "Tax",
      "refunds": "Refunds",
      "resellerMargin": "Reseller margin",
      "resellerNet": "Reseller net"
    },
    "col": {
      "tenant": "Tenant",
      "retail": "Retail",
      "wholesale": "Wholesale (our price)",
      "tax": "Tax",
      "refunds": "Refunds",
      "line": "Line",
      "resellerMargin": "Reseller margin",
      "resellerNet": "Reseller net (after affiliates)"
    },
    "line": {
      "BASE": "Subscriptions",
      "SEAT": "Guest seats",
      "CONNECTED": "Connected accounts",
      "AI": "AI",
      "TAX": "Tax"
    },
    "afterAffiliates": "after affiliates"
  },
  "payouts": {
    "empty": "No payout statements.",
    "loadError": "Could not load the payout run sheet.",
    "csvError": "Could not download the CSV.",
    "tableAria": "Payout run sheet",
    "linesAria": "Statement lines",
    "expand": "Expand lines",
    "collapse": "Collapse lines",
    "downloadCsv": "Download CSV",
    "summary_one": "{{count, number}} statement · {{payable}} payable · {{holds, number}} on hold",
    "summary_other": "{{count, number}} statements · {{payable}} payable · {{holds, number}} on hold",
    "status": {
      "PENDING": "Pending",
      "CARRIED": "Carried",
      "PAID": "Paid",
      "groupAria": "Payout status",
      "CHARGED": "Charged",
      "RETAINED": "Retained"
    },
    "col": {
      "payee": "Payee",
      "tenant": "Tenant",
      "period": "Period",
      "gross": "Gross",
      "carriedIn": "Carried in",
      "payable": "Payable",
      "method": "Method",
      "hold": "Hold",
      "status": "Status",
      "paid": "Paid",
      "actions": "Actions",
      "collected": "Collected",
      "kind": "Kind",
      "line": "Line",
      "retail": "Retail",
      "wholesale": "Wholesale",
      "uplift": "Uplift",
      "tenantShare": "Tenant share",
      "platform": "Platform",
      "shareApplied": "Share applied",
      "commission": "Commission",
      "payApiRef": "pay-api ref"
    },
    "payee": {
      "RESELLER": "Reseller",
      "AFFILIATE": "Affiliate"
    },
    "method": {
      "MANUAL": "Manual",
      "STRIPE_CONNECT_MANUAL": "Stripe Connect (manual payouts)",
      "STRIPE_CONNECT": "Stripe Connect (automatic payouts)"
    },
    "hold": {
      "HOLD_TAX_DOCS": "Tax docs",
      "HOLD_STRIPE_CONNECT": "Stripe Connect",
      "HOLD_TRANSFER_CURRENCY": "Transfer currency",
      "HOLD_TRANSFER_CAP": "Transfer cap",
      "HOLD_RESELLER_UNPAID": "Reseller charge unpaid",
      "HOLD_AFFILIATE_REVIEW": "Held for review (affiliate ended for cause)"
    },
    "kind": {
      "RENEWAL": "Renewal",
      "VARIABLE": "Variable",
      "REFUND": "Refund",
      "AFFILIATE_COMMISSION": "Affiliate commission",
      "ADDON_FEE": "Add-on fee",
      "BOUNTY": "Affiliate bounties",
      "MILESTONE": "Affiliate milestones",
      "CLAWBACK": "Clawback",
      "RECOVERY": "Recovered clawbacks"
    },
    "record": {
      "action": "Record payout…",
      "title": "Record payout",
      "amount": "Amount",
      "paidAt": "Paid at",
      "ref": "Reference",
      "refRequired": "Reference is required.",
      "override": "Record a different amount",
      "overrideHelp": "Only when the amount paid differs from the payable amount; give a reason.",
      "reason": "Reason",
      "reasonRequired": "Reason is required.",
      "submit": "Record",
      "cancel": "Cancel",
      "recorded": "Payout recorded.",
      "failed": "Could not record the payout.",
      "holdInfo": "On hold ({{hold}}); it can still be recorded.",
      "refusedHold": "Can't be recorded while {{hold}}.",
      "holdUnknown": "on hold",
      "notPayable": "This settlement was charged to the reseller's card; there's nothing to pay."
    },
    "allTenants": "All tenants",
    "paidViaPrefix": "paid via",
    "tenantCaptionNoReseller": "Payouts go to the tenant's reseller once one is assigned. Statements listed here are from before that change, and affiliate statements.",
    "tenantCaptionPrefix": "Payouts go to the tenant's reseller — see ",
    "tenantCaptionReseller": "{{resellerName}}'s Settlements",
    "tenantCaptionSuffix": ". Statements listed here are from before that change, and affiliate statements.",
    "unattributed": {
      "alert": "Revenue not yet attributed to a reseller: {{amounts}}",
      "row": "{{rows, number}} rows · {{retail}}"
    },
    "exportsStatus": "Exports {{status}} statements"
  },
  "ai": {
    "asOf": "As of {{date}}",
    "add": "Add model…",
    "added": "Price added.",
    "changed": "Price changed.",
    "changePrice": "Change price…",
    "changePriceFor": "Change price for {{name}} ({{currency}})",
    "tabs": {
      "models": "Models",
      "fast": "Fast tier assignment",
      "deep": "Deep tier assignment",
      "aria": "AI model prices sections",
      "naming": "Naming quality"
    },
    "scheduled": "Scheduled",
    "priceInUse": "A model assignment depends on this price. Change or withdraw that assignment first.",
    "withdrawPriceFor": "Withdraw the price starting {{when}}",
    "withdrawPriceTitle": "Withdraw a scheduled price",
    "withdrawPriceQuestion": "Withdraw the price starting {{when}}?",
    "models": {
      "caption": "Which model each tier calls. Changes apply to AI calls that start afterwards.",
      "fast": "Fast tier",
      "deep": "Deep tier",
      "emptyCurrent": "No model. AI on this tier is off until one is assigned.",
      "priced": "Priced in {{currencies}}.",
      "missing": "{{model}} has no price in {{currencies}}, so AI calls in those currencies are refused.",
      "addPrice": "Add the price on the Models tab.",
      "field": "Model",
      "fieldHelp": "The model this tier calls.",
      "notPriced": "{{model}} has no price in force at that time in {{currencies}}. Add the price first, then schedule again.",
      "loadError": "Could not load model assignments.",
      "tierMissing": "This tier isn't available.",
      "notOnTier": "That model isn't allowed on this tier. Tick the tier on the Models tab first.",
      "noneOnTier": "No models are allowed on this tier. Add one on the Models tab, with this tier ticked.",
      "openModels": "Open the Models tab",
      "effort": "Effort",
      "effortHelp": "How much the model thinks before answering. Higher effort costs more and can run out of room for the answer. Fast defaults to Low, Deep to Medium.",
      "effortVerifyHint": "Verify this model on the Models tab to choose another effort.",
      "effortNotTaken": "This model doesn't take that effort.",
      "effortVerify": "Verify the model on the Models tab to choose another effort.",
      "modelRetired": "Anthropic has retired this model. Choose another.",
      "effortNone": "This model takes no effort level. Choose a different model.",
      "noEffortWarning": "Anthropic no longer reports effort support for this model; schedule a different model.",
      "notVerifiedStructured": "Not verified for structured output. Verify it before assigning.",
      "noStructuredWarning": "Anthropic says this model no longer takes structured outputs; schedule a different model.",
      "modelNoStructured": "This model doesn't take structured outputs. Choose another.",
      "modelVerifyFirst": "Verify this model first.",
      "verifyModel": "Verify {{model}}"
    },
    "loadError": "Could not load the AI models and prices.",
    "inForce": "In force",
    "showHistory": "Show history",
    "hideHistory": "Hide history",
    "col": {
      "model": "Model",
      "currency": "Currency",
      "effectiveFrom": "Effective from",
      "inForce": "In force",
      "input": "Input / Mtok",
      "output": "Output / Mtok",
      "cacheRead": "Cache read / Mtok",
      "cacheWrite": "Cache write / Mtok",
      "added": "Added"
    },
    "form": {
      "title": "Add price: {{name}}",
      "addExplain": "Set the price in one currency.",
      "model": "Model",
      "currency": "Currency",
      "input": "Input / Mtok",
      "output": "Output / Mtok",
      "cacheRead": "Cache read / Mtok",
      "cacheWrite": "Cache write / Mtok",
      "microCaption": "Sends {{micro}} micro-units / Mtok",
      "submit": "Add price",
      "changeSubmit": "Change price",
      "changeTitle": "Change price: {{name}} ({{currency}})",
      "changeExplain": "Prices aren't edited in place. This starts a new price; AI usage before it keeps the price it was charged at.",
      "fromDate": "From a date",
      "dateRequired": "Choose a date.",
      "dateAfterToday": "Choose a date after today, or pick Now.",
      "outputAboveInput": "Output must cost more than input.",
      "saveAnyway": "Save anyway",
      "warn": {
        "cacheRead": "Cache read is usually cheaper than input.",
        "cacheWrite": "Cache write usually costs more than input.",
        "moved": "{{rate}} changes from {{from}} to {{to}}."
      },
      "cancel": "Cancel",
      "required": "Required.",
      "error": "Couldn't add the price.",
      "moreThanZero": "Must be more than zero.",
      "modelNotInCatalogue": "This model isn't in the catalogue. Add the model on the Models tab first."
    },
    "attention": {
      "loadError": "Could not load billing attention.",
      "none": "None.",
      "tabsAria": "Billing attention sections",
      "tabCount": "{{label}} ({{count, number}})",
      "tab": {
        "statements": "Statements",
        "divergences": "Divergences",
        "parked": "Parked payment events",
        "tax": "Tax classification"
      },
      "parked_one": "Parked payment events ({{count, number}})",
      "parked_other": "Parked payment events ({{count, number}})",
      "statementsAria": "Statements needing attention",
      "divergencesAria": "Reconcile divergences",
      "parkedAria": "Parked payment events",
      "feedStalled": "The payment feed has been stalled since {{since}}. Event {{seq, number}} is blocked by a lock.",
      "lastAttemptFailed": "The last attempt failed.",
      "copyDetails": "Copy details for support",
      "copyDetailsAria": "Copy details for support for statement {{id, number}}",
      "col": {
        "period": "Period",
        "status": "Status",
        "total": "Total",
        "attempts": "Attempts",
        "lastError": "Last error",
        "subscriptionId": "Subscription id",
        "payApi": "pay-api subscription",
        "fields": "Fields",
        "seq": "Seq",
        "eventType": "Event type",
        "appliedAt": "Applied at",
        "count": "Count",
        "oldest": "Oldest",
        "product": "Product",
        "since": "Since",
        "details": "Details",
        "charge": "Charge",
        "chargeId": "Charge id",
        "tenantId": "Tenant id",
        "resellerId": "Reseller id",
        "failedAt": "Failed at"
      },
      "declare": {
        "action": "Declare products…",
        "title": "Send tmm's product list to pay-api again?",
        "body": "It's safe to repeat.",
        "confirm": "Declare products",
        "done": "Products declared.",
        "error": "Couldn't declare the products.",
        "someFailed": "Some products couldn't be declared. Try again; it's safe to repeat."
      },
      "unhandled": {
        "title": "Unhandled payment events",
        "note": "Payment events tmm-api doesn't handle yet. They're kept and applied once a build handles them.",
        "aria": "Unhandled payment events"
      },
      "skuReview": {
        "title": "Products to review",
        "note": "Review the product's tax classification in pay-api's registry.",
        "aria": "Products to review",
        "copyAria": "Copy details for support for product {{identifier}}"
      },
      "taxClassification": {
        "note": "A product needs a tax classification in pay-api before it can be charged.",
        "aria": "Tax classification required",
        "copyAria": "Copy details for support for charge {{id}}"
      },
      "sku": {
        "tmm_subscription": "Subscription",
        "tmm_guests": "Guests",
        "tmm_connections": "Connections",
        "tmm_ai_wallet_credit": "AI wallet credit",
        "tmm_partner_addon_custom_ui": "Partner add-on: custom UI",
        "tmm_partner_addon_mobile_app": "Partner add-on: mobile app",
        "tmm_partner_minimum_shortfall": "Partner minimum shortfall",
        "tmm_partner_statement_deficit": "Partner statement deficit"
      },
      "chargeKind": {
        "WALLET_CHARGE": "AI wallet charge",
        "ADDON_CHARGE": "Add-on charge",
        "RESELLER_CHARGE": "Reseller charge"
      }
    },
    "effort": {
      "LOW": "Low",
      "MEDIUM": "Medium",
      "HIGH": "High",
      "XHIGH": "Extra high",
      "MAX": "Max"
    },
    "catalog": {
      "tier": {
        "FAST": "Fast",
        "DEEP": "Deep"
      },
      "and": " and ",
      "inUse": "The {{tiers}} tier uses this model. Assign another model there first.",
      "inUseNoTiers": "A tier uses this model. Assign another model there first.",
      "unavailable": "We couldn't reach Anthropic to check the model. Nothing was saved. Try again in a moment.",
      "form": {
        "tiers": "Tiers",
        "tierRequired": "Choose at least one tier.",
        "modelId": "Model id",
        "modelIdRule": "Lower-case letters, numbers, dots and hyphens. Exactly as Anthropic names it."
      },
      "notAtProvider": "Anthropic doesn't know that model id. Check the spelling.",
      "exists": "That model is already in the catalogue.",
      "add": {
        "title": "Add model",
        "submit": "Add model",
        "consequence": "We check the id with Anthropic before saving it.",
        "error": "Couldn't add the model."
      },
      "added": "{{model}} added.",
      "edit": {
        "title": "Edit tiers: {{model}}",
        "submit": "Save",
        "saved": "Tiers saved.",
        "error": "Couldn't change the tiers."
      },
      "notFound": "That model couldn't be found.",
      "retire": {
        "action": "Retire…",
        "title": "Retire a model",
        "question": "Retire {{model}}? Its prices and history stay.",
        "confirm": "Retire",
        "error": "Couldn't retire the model."
      },
      "retired": "{{model}} retired.",
      "retiredLine": "Retired {{date}} by {{who}}",
      "verify": "Verify",
      "verified": "Checked with Anthropic.",
      "checking": "Checking with Anthropic…",
      "goneAtProvider": "Anthropic no longer knows this model. It hasn't been retired; retire it when nothing uses it.",
      "verifyError": "Couldn't check the model.",
      "notVerified": "Not verified",
      "pricesFor": "Prices for {{model}}",
      "noPrices": "No prices yet. Add one before assigning this model.",
      "showPrices": "Show prices for {{model}}",
      "hidePrices": "Hide prices for {{model}}",
      "addPrice": "Add price…",
      "addPriceFor": "Add price for {{model}}",
      "editTiers": "Edit tiers…",
      "showRetired": "Show retired",
      "empty": "No models yet. Add one to price it and assign it to a tier.",
      "tableAria": "AI model catalogue",
      "col": {
        "tiers": "Tiers",
        "usedBy": "In use by",
        "verified": "Verified",
        "efforts": "Efforts",
        "structured": "Structured output"
      },
      "showOutside_one": "Show {{count, number}} price for models outside the catalogue",
      "showOutside_other": "Show {{count, number}} prices for models outside the catalogue",
      "hideOutside": "Hide prices for models outside the catalogue",
      "outsideCaption": "These can't be assigned. Add the model to the catalogue to use it.",
      "outsideAria": "Prices for models outside the catalogue",
      "unavailableAuth": "Anthropic refused our API key. Ask the platform operator to check the key; nothing was saved.",
      "notSupported": {
        "RETIRED": "Anthropic has retired that model. It can't be added.",
        "NO_EFFORT": "That model doesn't take an effort setting, which every AI call sends. It can't be added.",
        "NO_STRUCTURED_OUTPUT": "That model doesn't take structured outputs, which every AI call needs. It can't be added."
      },
      "effortsNotChecked": "Not checked",
      "effortsHint": "Verify fills this in.",
      "effortsNone": "None (can't be assigned)",
      "noEffortChip": "No effort support",
      "noEffortReason": "Anthropic reports no effort support; this model can't be assigned.",
      "structuredYes": "Yes",
      "structuredNo": "No (can't be assigned)",
      "structuredNotChecked": "Not checked",
      "structuredHint": "Verify fills this in.",
      "noStructuredChip": "No structured output",
      "noStructuredReason": "Anthropic says this model doesn't take structured outputs; it can't be assigned.",
      "lifecycle": {
        "retiresOn": "Retires on {{date}}",
        "deprecated": "Deprecated",
        "retired": "Retired by Anthropic"
      },
      "retiredGroup": "Retired models",
      "retiredCaption": "This model is retired. Add it again on this tab to use it; its prices stay.",
      "retiredAria": "Prices for retired models"
    }
  },
  "parkedEvents": {
    "retention": "Re-apply works for 90 days after the payment event.",
    "tabsAria": "Parked payment events by resolution",
    "tab": {
      "unresolved": "Unresolved",
      "resolved": "Resolved"
    },
    "tableAria": "Parked payment events",
    "regionAria": "Parked payment events list",
    "loadError": "Could not load parked payment events.",
    "empty": "No parked payment events.",
    "emptyResolved": "Nothing resolved yet.",
    "col": {
      "parked": "Parked",
      "event": "Event",
      "reason": "Reason",
      "attempts": "Attempts",
      "payment": "Payment",
      "subscription": "Subscription",
      "resolution": "Resolution",
      "resolved": "Resolved",
      "by": "By",
      "note": "Note",
      "actions": "Actions"
    },
    "eventType": {
      "subscription_renewed": "Subscription renewed",
      "subscription_payment_failed": "Subscription payment failed",
      "subscription_canceled": "Subscription canceled",
      "subscription_activated": "Subscription activated",
      "subscription_payment_method_updated": "Payment method updated",
      "subscription_paused": "Subscription paused",
      "subscription_resumed": "Subscription resumed",
      "subscription_plan_changed": "Plan changed",
      "subscription_renewal_upcoming": "Renewal upcoming",
      "payment_succeeded": "Payment succeeded",
      "payment_failed": "Payment failed",
      "payment_refunded": "Payment refunded",
      "connect_account_updated": "Connected account updated",
      "transfer_created": "Transfer created",
      "transfer_failed": "Transfer failed",
      "transfer_reversed": "Transfer reversed",
      "transfer_reversal_failed": "Transfer reversal failed"
    },
    "reason": {
      "REFUND_EXCEEDS_PAYMENT": "The refund is larger than the payment.",
      "REFUND_CURRENCY_MISMATCH": "The refund's currency differs from the payment's.",
      "REFUND_PARENT_MISSING": "The refund doesn't say which charge it refunds.",
      "REFUND_PARENT_NOT_MIRRORED": "The original charge isn't recorded yet. Re-apply once it is.",
      "REFUND_CURRENCY_MISSING": "The refund has no currency.",
      "REFUND_FIELDS_MISSING": "The refund is missing required details.",
      "DISPUTE_FIELDS_MISSING": "The dispute is missing required details.",
      "HANDLER_FAILED": "Applying it failed three times."
    },
    "reasonUnknown": "The event couldn't be applied.",
    "resolution": {
      "REAPPLIED": "Re-applied",
      "DISMISSED": "Dismissed"
    },
    "reapply": {
      "title": "Re-apply event {{seq, number}}?",
      "consequence": "tmm-api fetches it from pay-api and applies it once.",
      "confirm": "Re-apply",
      "rowAria": "Re-apply event {{seq, number}}",
      "done": "Event re-applied.",
      "failed": "Couldn't re-apply the event.",
      "stillRefused": "Still refused: {{reason}}.",
      "payApiUnavailable": "pay-api isn't available right now, so the event can't be fetched. Try again later."
    },
    "dismiss": {
      "title": "Dismiss event {{seq, number}}?",
      "consequence": "Nothing is applied. Use this when it was handled elsewhere, or when the member was erased.",
      "confirm": "Dismiss",
      "rowAria": "Dismiss event {{seq, number}}",
      "done": "Event dismissed.",
      "failed": "Couldn't dismiss the event."
    },
    "dismissInstead": "Dismiss instead",
    "lastRefusal": "Last re-apply refused just now: {{reason}}",
    "dialog": {
      "note": "Note",
      "counter": "{{count, number}}/{{max, number}}",
      "noteRule": "Write a note of 3 to 500 characters."
    },
    "support": {
      "label": "Details for support",
      "rowAria": "Copy details for support for event {{seq, number}}"
    }
  },
  "deletions": {
    "empty": "No deletion requests.",
    "loadError": "Could not load deletion requests.",
    "requested": "Deletion requested.",
    "cancelled": "Deletion request cancelled.",
    "tableAria": "Deletion requests",
    "requestedBy": "by {{who}}",
    "copyDetailsAria": "Copy details for support for deletion request {{id, number}}",
    "cancel": "Cancel…",
    "counter": "{{n, number}}/200",
    "col": {
      "person": "Person",
      "requested": "Requested",
      "coolingOff": "Cooling-off until",
      "status": "Status",
      "erasedAt": "Erased at",
      "attempts": "Attempts",
      "actions": "Actions"
    },
    "status": {
      "PENDING": "Pending",
      "CANCELLED": "Cancelled",
      "ERASING": "Erasing",
      "ERASED": "Erased",
      "FAILED": "Failed"
    },
    "request": {
      "action": "Request deletion…",
      "warning": "Everything this person owns is erased after the cooling-off period. They are emailed and can cancel.",
      "error": "Couldn't request the deletion."
    },
    "requestDialog": {
      "title": "Request deletion",
      "person": "Person",
      "personRequired": "Person is required.",
      "reason": "Reason",
      "reasonRequired": "Reason is required.",
      "submit": "Request",
      "cancel": "Cancel"
    },
    "cancelDialog": {
      "titleNamed": "Cancel the deletion request for {{person}}?",
      "consequence": "Nothing this person owns will be erased.",
      "reason": "Reason",
      "confirm": "Cancel deletion",
      "error": "Couldn't cancel the deletion request.",
      "keep": "Keep deletion request"
    },
    "erase": {
      "action": "Erase now…",
      "title": "Erase this account now?",
      "body": "This permanently deletes {{person}}'s data now instead of at the scheduled time. It can't be undone.",
      "confirm": "Erase now",
      "erased": "Account erased.",
      "retrying": "Erasure started; it will finish in the background.",
      "cancelledError": "This request was cancelled, so it can't be erased.",
      "notFoundError": "This request no longer exists.",
      "error": "Couldn't erase the account.",
      "retryTitle": "Try erasing this account again?",
      "retryBody": "The last attempt failed. This tries again now, and can't be undone once it succeeds.",
      "failedAgain": "The erasure failed again: {{reason}}."
    },
    "errorCode": {
      "ASSOCIATION_HOLD": "The account's subscription couldn't be matched at pay-api yet.",
      "PAY_API_UNAVAILABLE": "pay-api didn't answer.",
      "PAY_API_REFUSED": "pay-api refused the request.",
      "ERASURE_IN_PROGRESS": "pay-api is still erasing the payment records.",
      "IDEMPOTENCY_CONFLICT": "pay-api reported a conflict on the erasure request.",
      "STEP_FAILED": "A step of the erasure failed.",
      "UNKNOWN": "Erasure failed."
    }
  },
  "aiUsage": {
    "tabs": {
      "aria": "AI usage sections",
      "features": "By feature",
      "people": "By person"
    },
    "empty": "No AI usage in this period.",
    "loadError": "Could not load AI usage.",
    "range": "{{from}} – {{to}}",
    "showing": "Showing {{person}}",
    "details": "Details",
    "atOurPriceAbsent": "— means no offer prices this usage at our price.",
    "atOurPricePartial": "Partial",
    "atOurPricePartialHelp": "— means no offer prices this usage at our price. Partial means some people's usage isn't priced at our price, so no total is shown.",
    "kpi": {
      "requests": "Requests",
      "failed": "Failed",
      "totalTokens": "Total tokens"
    },
    "tableAria": {
      "features": "AI usage by feature",
      "people": "AI usage by person"
    },
    "col": {
      "feature": "Feature",
      "requests": "Requests",
      "failed": "Failed",
      "input": "Input",
      "output": "Output",
      "cacheRead": "Cache read",
      "cacheWrite": "Cache write",
      "totalTokens": "Total tokens",
      "cost": "Cost",
      "atOurPrice": "At our price",
      "charge": "Est. charge",
      "person": "Person",
      "actions": "Actions",
      "walletUsage": "Wallet usage",
      "balance": "Balance"
    },
    "feature": {
      "IMPORT_MAPPING": "Import mapping",
      "CATEGORY_SUGGESTION": "Category suggestion",
      "MEETING_SUMMARY": "Meeting summary",
      "MATCH_SUGGESTION": "Match suggestion",
      "DOMAIN_SETUP": "Domain setup",
      "PAYEE_SUGGESTION": "Payee suggestion",
      "PAYEE_PATTERN": "Payee patterns",
      "ENVELOPE_ANALYSIS": "Envelope analysis",
      "FINANCIAL_ASSISTANT": "My Financial Assistant",
      "SUPPORT_ASSISTANT": "Support assistant"
    },
    "wallet": {
      "toggle": "Wallet",
      "purchases": "Purchases",
      "recharges": "Recharges",
      "topUps": "Top-ups",
      "monthlyCredits": "Monthly credits",
      "adminCredits": "Admin credits",
      "usage": "Usage",
      "balance": "Balance"
    },
    "suspended": "AI suspended by the platform",
    "suspendedSince": "Since {{date}}",
    "credit": {
      "action": "Add AI credit…",
      "title": "Add AI credit for {{person}}",
      "amount": "Amount",
      "reason": "Reason",
      "amountRule": "Enter an amount above zero and at most 10,000,000.00.",
      "reasonRequired": "Reason is required.",
      "reasonTooLong": "Use at most 255 characters.",
      "consequence": "{{amount}} is added to {{person}}'s AI wallet. It's recorded with your reason.",
      "consequenceNoWallet": "{{amount}} in their subscription's currency is added to {{person}}'s AI wallet. It's recorded with your reason.",
      "confirm": "Add credit",
      "added": "Added {{amount}}. Their AI balance is {{balance}}.",
      "noSubscription": "This person has no live subscription, so their AI wallet can't be credited.",
      "keyConflict": "This credit was already sent with a different amount. Close this and start again.",
      "error": "Couldn't add the AI credit."
    }
  },
  "customers": {
    "invite": {
      "action": "Invite customer…",
      "title": "Invite customer",
      "email": "Email",
      "emailRequired": "Email is required.",
      "emailInvalid": "Enter a valid email.",
      "submit": "Invite",
      "cancel": "Cancel",
      "sent": "Invitation sent to {{email}}.",
      "created": "Invitation created for {{email}}; the email could not be sent.",
      "error": "Could not invite customer."
    }
  },
  "paymentsSetup": {
    "title": "Billing setup",
    "refresh": "Refresh billing config",
    "refreshing": "Refreshing billing config…",
    "refreshed": "Billing setup refreshed.",
    "refreshError": "Could not refresh the billing setup.",
    "refreshUnavailable": "pay-api has no billing setup for this tenant, or couldn't be reached. Check the tenant in pay-api, then refresh again.",
    "loadError": "Could not load the billing setup.",
    "empty": "No billing setup is cached for this tenant. Refresh to read it from pay-api.",
    "field": {
      "provider": "Provider",
      "environment": "Environment",
      "flow": "Flow",
      "stripeAccount": "Stripe account",
      "publishableKey": "Publishable key"
    },
    "connection": {
      "label": "Billing connection",
      "provisioned": "Provisioned {{date}}",
      "notProvisioned": "Not provisioned"
    },
    "provision": {
      "open": "Provision billing…",
      "title": "Provision billing for {{name}}?",
      "consequence": "This sets up the tenant's billing on the platform's Stripe account in pay-api and activates it in {{currency}}. Charges outside the configured range are refused. It's safe to repeat.",
      "confirm": "Provision billing",
      "done": "Billing provisioned.",
      "error": "Could not provision billing.",
      "reason": {
        "CONNECTION_EXISTS": "This tenant already has a different billing connection in pay-api: a connected account, another provider, or the other environment. Someone must remove it in pay-api before billing can be provisioned here.",
        "STRIPE_ENVIRONMENT_UNSET": "tmm-api's Stripe environment isn't set, so nothing was sent to pay-api. Ask the platform team.",
        "HOUSE_MODE_NOT_ALLOWED": "pay-api doesn't allow tmm to bill on the platform's Stripe account yet. Ask the platform team.",
        "HOUSE_MODE_UNAVAILABLE": "pay-api doesn't support billing on the platform's Stripe account yet. Ask the platform team.",
        "ACTIVATION_REFUSED": "pay-api refused to activate the billing connection.",
        "PAY_API_UNAVAILABLE": "pay-api isn't available right now. Try again; it's safe to repeat."
      }
    }
  },
  "whitelabel": {
    "title": "Custom domain",
    "none": "No custom domain. Tenants use the platform hostnames.",
    "setUp": "Set up a domain…",
    "loadError": "Could not load the custom domain.",
    "domain": "Domain",
    "stateLabel": "State",
    "state": {
      "DRAFT": "Waiting for DNS",
      "ACTIVE": "Live"
    },
    "activatedAt": "Activated",
    "hostnames": "Hostnames",
    "col": {
      "hostname": "Hostname",
      "type": "Type",
      "app": "App",
      "dns": "DNS"
    },
    "type": {
      "APP": "App",
      "LOGIN": "Login",
      "AUTH": "Auth",
      "API": "API",
      "ASSET": "Assets",
      "BRAND": "Brand center"
    },
    "verified": "Verified",
    "notVerified": "Not verified",
    "records": {
      "title": "DNS records to create",
      "host": "Host",
      "type": "Type",
      "target": "Target",
      "verified": "Verified"
    },
    "copy": "Copy {{value}}",
    "verify": "Verify DNS",
    "verifying": "Verifying DNS",
    "verifyWait": "This can take up to a minute.",
    "verifyError": "Could not verify DNS.",
    "results": {
      "title": "Latest check",
      "thisCheck": "This check",
      "matched": "Matched",
      "notMatched": "No match",
      "allVerified": "Every hostname is verified.",
      "someFailed": "Some hostnames did not verify. Check the DNS records and try again."
    },
    "change": "Change domain…",
    "remove": "Remove…",
    "removeTitle": "Remove the custom domain?",
    "removeBody": "The tenant goes back to the platform hostnames. DNS records you created can be deleted afterwards.",
    "removeConfirm": "Remove",
    "removed": "Custom domain removed.",
    "removeError": "Could not remove the custom domain.",
    "note": {
      "required": "Required",
      "optional": "Optional"
    },
    "set": {
      "title": "Set up a domain",
      "changeTitle": "Change domain",
      "domainLabel": "Domain",
      "domainHelper": "The customer’s own domain, e.g. example.com",
      "domainRequired": "Domain is required.",
      "domainTooLong": "Domain must be 255 characters or fewer.",
      "include": "Include",
      "includeHost": "Include {{prefix}}",
      "prefix": "Prefix",
      "prefixFor": "Prefix for {{prefix}}",
      "prefixRequired": "Prefix is required.",
      "prefixTooLong": "Prefix must be 63 characters or fewer.",
      "note": "Note",
      "noneChecked": "Choose at least one hostname.",
      "templateError": "Could not load the suggested hostnames.",
      "saveError": "Could not save the domain.",
      "saved": "Domain saved. Create the DNS records, then verify.",
      "cancel": "Cancel",
      "save": "Save",
      "refused": "That domain can't be used. Check it and try again.",
      "domainName": "the custom domain"
    }
  },
  "addons": {
    "tabs": {
      "aria": "Add-on sections"
    },
    "catalog": {
      "title": "Catalogue",
      "tableAria": "Add-on catalogue",
      "empty": "Nothing in the catalogue yet.",
      "loadError": "Could not load the catalogue.",
      "col": {
        "name": "Name",
        "period": "Period",
        "price": "Price",
        "billing": "Billing",
        "status": "Status",
        "actions": "Actions"
      }
    },
    "fleet": {
      "title": "Tenant add-ons",
      "statusAria": "Add-on status",
      "all": "All",
      "loadError": "Could not load tenants' add-ons.",
      "tableAria": "Tenant add-ons",
      "empty": "No tenant add-ons."
    },
    "tenant": {
      "tableAria": "Tenant add-ons",
      "empty": "No add-ons for this tenant.",
      "loadError": "Could not load add-ons.",
      "expand": "Show charges for {{name}}",
      "collapse": "Hide charges for {{name}}",
      "cancels": "Cancels {{date}}"
    },
    "col": {
      "tenant": "Tenant",
      "addon": "Add-on",
      "status": "Status",
      "billingMode": "Billing mode",
      "price": "Price per period",
      "term": "Term",
      "autoRenew": "Auto-renew",
      "revenueYear": "Revenue this year",
      "offered": "Offered",
      "accepted": "Accepted",
      "actions": "Actions"
    },
    "charges": {
      "empty": "No charges yet.",
      "tableAria": "Charges for {{name}}",
      "copyDetailsAria": "Copy details for support for charge {{id, number}}",
      "col": {
        "period": "Period",
        "amount": "Amount",
        "mode": "Mode",
        "status": "Status",
        "card": "Card",
        "attempt": "Attempt",
        "lastError": "Last error",
        "actions": "Actions"
      }
    },
    "catalogStatus": {
      "DRAFT": "Draft",
      "ACTIVE": "Active",
      "RETIRED": "Retired"
    },
    "period": {
      "ANNUAL": "Annual",
      "MONTHLY": "Monthly"
    },
    "perPeriod": {
      "ANNUAL": "/ year",
      "MONTHLY": "/ month"
    },
    "allowedBilling": {
      "CARD": "Card",
      "NET_FROM_PAYOUTS": "Net from payouts",
      "BOTH": "Card or net from payouts"
    },
    "billingMode": {
      "CARD": "Card",
      "NET_FROM_PAYOUTS": "Net from payouts"
    },
    "status": {
      "OFFERED": "Offered",
      "ACTIVE": "Active",
      "PAST_DUE": "Past due",
      "LAPSED": "Lapsed",
      "CANCELLED": "Cancelled",
      "DECLINED": "Declined",
      "WITHDRAWN": "Withdrawn"
    },
    "chargeStatus": {
      "PENDING": "Pending",
      "PAID": "Paid",
      "FAILED": "Failed",
      "ACTION_REQUIRED": "Action required",
      "NETTING": "Netting",
      "NETTED": "Netted",
      "WAIVED": "Waived",
      "REFUNDED": "Refunded"
    },
    "chargeMode": {
      "CARD": "Card",
      "NETTED": "Netted"
    },
    "yes": "Yes",
    "no": "No",
    "actions": {
      "new": "New add-on…",
      "edit": "Edit…",
      "activate": "Activate",
      "retire": "Retire",
      "reinstate": "Reinstate…",
      "cancel": "Cancel",
      "save": "Save",
      "create": "Create",
      "offer": "Offer add-on…",
      "withdraw": "Withdraw",
      "cancelAddon": "Cancel…",
      "waive": "Waive…"
    },
    "form": {
      "createTitle": "New add-on",
      "editTitle": "Edit add-on",
      "kind": "Kind",
      "kindHelp": "A stable key, e.g. BRANDED_APP. Fixed once created.",
      "kindInvalid": "A letter, then up to 31 letters, digits or underscores.",
      "name": "Name",
      "description": "Description",
      "period": "Period",
      "currency": "Currency",
      "defaultPrice": "Default price",
      "defaultPriceHelp": "Optional.",
      "minorCaption": "Sends {{minor}} minor units",
      "allowedBilling": "Allowed billing",
      "required": "Required.",
      "tooLong": "At most {{max, number}} characters.",
      "nonNegative": "Must be zero or greater."
    },
    "activate": {
      "title": "Activate {{name}}?",
      "confirm": "Tenants can then be offered it."
    },
    "reinstate": {
      "title": "Reinstate {{name}}?",
      "confirm": "It can be offered to tenants again.",
      "action": "Reinstate"
    },
    "retire": {
      "title": "Retire {{name}}?",
      "confirm": "It can't be offered any more. Tenants who have it keep it."
    },
    "activated": "{{name}} is active.",
    "retired": "{{name}} is retired.",
    "created": "{{name}} was added as a draft.",
    "updated": "{{name}} was saved.",
    "saveError": "Could not save the add-on.",
    "actionError": "Could not update the add-on.",
    "offer": {
      "title": "Offer add-on",
      "addon": "Add-on",
      "chooseAddon": "Choose an add-on.",
      "noneActive": "No active add-ons in the catalogue.",
      "price": "Price per period",
      "termStart": "Term start (optional)",
      "autoRenew": "Auto-renew",
      "notes": "Notes (optional)",
      "submit": "Offer"
    },
    "withdraw": {
      "title": "Withdraw the offer?",
      "confirm": "Withdraw the offer of {{name}}? The tenant can no longer accept it."
    },
    "cancel": {
      "title": "Cancel {{name}}?",
      "atTermEnd": "At the end of the term",
      "termEndCaption": "Service continues until {{date}}.",
      "termEndCaptionUnknown": "Service continues until the end of the current term.",
      "immediately": "Immediately — service stops now.",
      "reason": "Reason (optional)",
      "keep": "Keep add-on",
      "submit": "Cancel add-on"
    },
    "waive": {
      "title": "Waive charge",
      "reason": "Reason",
      "reasonRequired": "Reason is required.",
      "submit": "Waive"
    },
    "merchantUnset": "Merchant of record is not set.",
    "openSettings": "Open Settings"
  },
  "settings": {
    "nav": {
      "commerce": "Commerce",
      "operations": "Operations",
      "other": "Other",
      "fees": "Processing fees",
      "standingCc": "Standing CC"
    },
    "maintenance": {
      "title": "Billing maintenance",
      "help": "One-off actions for the billing setup.",
      "backfill": {
        "action": "Backfill payees…",
        "title": "Register existing partners as payees in pay-api?",
        "body": "Run this once, after pay-api's adoption. It's audited.",
        "confirm": "Backfill payees",
        "error": "Couldn't run the payee backfill.",
        "done": "Payee backfill finished.",
        "matched": "Matched {{value, number}}",
        "stored": "Stored {{value, number}}",
        "kindFixed": "Kind corrected {{value, number}}",
        "kindUnavailable": "Kind not correctable yet {{value, number}}",
        "policySet": "Policy set {{value, number}}",
        "unmatched": "Unmatched {{value, number}}",
        "failed": "Failed {{value, number}}",
        "failedIds": "Not stored: {{ids}}",
        "runAgain": "Some payees' kind couldn't be corrected yet. Run this again once pay-api has it."
      }
    },
    "col": {
      "key": "Key",
      "updated": "Updated",
      "value": "Value"
    },
    "loadError": "Could not load product settings.",
    "merchant": {
      "change": "Change…",
      "changeTitle": "Change merchant of record",
      "help": "The tenant whose payment account charges tenants for add-ons.",
      "saveError": "Could not save the setting.",
      "tenantLabel": "Tenant",
      "title": "Merchant of record",
      "unset": "Not set. Add-on card charges are paused until this is set.",
      "concurrent": "Someone else changed this at the same time. Try again."
    },
    "seller": {
      "title": "Seller and terms",
      "name": "Seller name",
      "legalName": "Legal name",
      "version": "Terms version",
      "termsUrl": "Terms URL",
      "privacyUrl": "Privacy policy URL",
      "versionHint": "Letters, digits, dot, underscore or dash; up to 32. For example 2026-10.",
      "urlHint": "Leave empty to show none.",
      "nameRequired": "Seller name is required.",
      "legalNameRequired": "Legal name is required.",
      "versionRequired": "Terms version is required.",
      "versionInvalid": "Use only letters, digits, dot, underscore or dash; up to 32.",
      "urlInvalid": "Enter an https address of at most {{max, number}} characters, or leave it empty.",
      "tooLong": "At most {{max, number}} characters.",
      "saved": "Seller and terms saved.",
      "unchanged": "Nothing changed, so nothing was saved.",
      "versionConfirm": {
        "title": "Change the terms version to {{termsVersion}}?",
        "body": "New subscribers must accept version {{termsVersion}} before subscribing. Existing subscribers aren't forced to re-accept; the app may ask them. Their subscriptions continue.",
        "confirm": "Change version"
      }
    },
    "other": {
      "title": "Other settings",
      "empty": "No other settings."
    },
    "updatedAt": "Updated {{when}}",
    "standingCc": {
      "title": "Standing notice CC",
      "helper": "Comma-separated email addresses copied on every standing notice",
      "invalid": "“{{entry}}” isn’t an email address.",
      "tooLong": "At most {{max, number}} characters in all.",
      "save": "Save CC",
      "saved": "Standing notice CC saved."
    },
    "processing": {
      "title": "Card processing fees",
      "help": "What the card processor charges us on each collected charge, per currency. The reseller pays its margin's share. A change applies from now.",
      "col": {
        "currency": "Currency",
        "percent": "Percent",
        "fixed": "Fixed per charge",
        "since": "In force since"
      },
      "saved": "{{currency}} card processing fee saved.",
      "invalid": "Check the percent (0 to 100) and the fixed fee (0 or more).",
      "error": "Couldn't save the card processing fee.",
      "loadError": "Couldn't load the {{currency}} rate.",
      "percentLabel": "{{currency}} percent",
      "fixedLabel": "{{currency}} fixed per charge",
      "save": "Save",
      "none": "Not set: no processing fee is counted in {{currency}}.",
      "next": "Next: {{percent}} + {{fixed}} from {{when}}",
      "edit": "Edit {{currency}}…"
    }
  },
  "resellerCards": {
    "col": {
      "actions": "Actions"
    },
    "noncompliant": {
      "label": "Non-compliant",
      "since": "Non-compliant since {{date}}"
    },
    "form": {
      "annualEmpty": "Leave empty to offer monthly only."
    }
  },
  "customerRateCards": {
    "versionLabel": "v{{version, number}}",
    "noCurrent": "No published version",
    "actions": {
      "editDetails": "Edit details…",
      "newVersion": "New version…",
      "publish": "Publish…",
      "saveDraft": "Save draft",
      "grant": "Grant to reseller…",
      "revoke": "Revoke…",
      "move": "Move subscribers…",
      "adopt": "Adopt…"
    },
    "status": {
      "DRAFT": "Draft",
      "PUBLISHED": "Published",
      "RETIRED": "Retired"
    },
    "chip": {
      "current": "Current"
    },
    "tabs": {
      "versions": "Versions",
      "grants": "Grants",
      "controls": "Controls"
    },
    "versions": {
      "tableAria": "Versions",
      "version": "Version",
      "state": "State",
      "published": "Published",
      "subscribers": "Subscribers",
      "empty": "No versions yet.",
      "newError": "Couldn't add a version."
    },
    "grants": {
      "reseller": "Reseller",
      "adoption": "Adoption",
      "adopted": "Adopts this card",
      "notAdopted": "Granted",
      "empty": "No reseller has this card.",
      "unpublished": "Resellers can't see this card until a version is published."
    },
    "create": {
      "submit": "Create card",
      "nameRequired": "Name is required."
    },
    "publish": {
      "title": "Publish version {{version, number}}",
      "consequence": "Publish version {{version, number}}? New sales use it. Existing subscribers stay on their version until you move them.",
      "confirm": "Publish"
    },
    "move": {
      "title": "Move subscribers",
      "consequence": "Move this card's subscribers on older versions to version {{version, number}}? Each one moved is sent a notice.",
      "confirm": "Move subscribers",
      "result": "Moved {{moved, number}}. Already on this version: {{already, number}}. Failed: {{failed, number}}.",
      "failedWarning": "Some subscribers were not moved.",
      "error": "Couldn't move subscribers."
    },
    "grant": {
      "title": "Grant to reseller",
      "reseller": "Reseller",
      "confirm": "Grant",
      "empty": "Every reseller already has this card."
    },
    "revoke": {
      "title": "Revoke grant",
      "consequence": "Revoke this grant for {{reseller}}?",
      "confirm": "Revoke",
      "error": "Couldn't revoke this grant.",
      "adopted": "{{reseller}} uses this card. It must adopt another before this grant can be revoked."
    },
    "adopt": {
      "title": "Adopt rate card",
      "confirm": "Adopt",
      "consequence": "Adopt {{name}} for this reseller?",
      "notPublished": "This card has no published version.",
      "empty": "No card adopted",
      "noneGranted": "No rate card is granted to this reseller.",
      "error": "Couldn't adopt this rate card."
    },
    "errors": {
      "save": "Couldn't save this version.",
      "immutable": "Only a draft version can be edited."
    },
    "form": {
      "aiFirstPurchase": "AI first purchase",
      "aiRechargeTrigger": "Recharge when the balance falls below",
      "moreThanZero": "Must be more than zero.",
      "moreThanTrigger": "Must be more than the recharge trigger.",
      "between0And100": "Must be between 0 and 100."
    },
    "toast": {
      "published": "Version {{version, number}} is published.",
      "granted": "Granted to {{reseller}}.",
      "revoked": "Grant revoked.",
      "versionAdded": "Version {{version, number}} is a new draft.",
      "adopted": "{{name}} is the adopted card."
    }
  },
  "tenantRateCard": {
    "activateOrFix": "Activate or fix the card first."
  },
  "resellerBilling": {
    "cardTitle": "Card on file",
    "noCard": "No card on file. The reseller adds one in its console; until then deficits and shortfalls can't be charged.",
    "brand": "Brand",
    "number": "Number",
    "last4": "•••• {{last4}}",
    "expiry": "Expires",
    "expiryValue": "{{mm}}/{{yyyy}}",
    "status": "Status",
    "cardReadOnly": "Read-only. The reseller manages its card.",
    "cardStatus": {
      "ACTIVE": "Active",
      "EXPIRED": "Card expired",
      "requires_action": "Needs the reseller's confirmation"
    },
    "theCard": "the card on file",
    "chargesTitle": "Charges",
    "col": {
      "period": "Period",
      "kind": "Kind",
      "amount": "Amount",
      "status": "Status",
      "attempt": "Attempt",
      "nextRetry": "Next retry",
      "holdsPayouts": "Holds payouts",
      "failure": "Failure",
      "actions": "Actions"
    },
    "noCharges": "No charges.",
    "kind": {
      "MINIMUM_SHORTFALL": "Minimum shortfall",
      "STATEMENT_DEFICIT": "Statement deficit"
    },
    "chargeStatus": {
      "PENDING": "Pending",
      "REQUESTED": "Processing",
      "SUCCEEDED": "Charge collected",
      "FAILED": "Failed",
      "REQUIRES_ACTION": "Needs action"
    },
    "holdingPayouts": "Holding payouts",
    "linkedCharge": "Linked charge",
    "failure": {
      "NO_CARD": "No card on file",
      "REVERIFY_CARD": "The bank wants the card confirmed; the reseller adds it again",
      "PSP_ERROR": "The payment provider had an error",
      "FAILED": "Declined"
    },
    "retry": "Retry",
    "retryAria": "Retry the {{period}} charge",
    "confirm": {
      "title": "Retry charging {{amount}} to the card on file?",
      "body": "The charge is sent to {{card}} now.",
      "noCard": "There is no card on file, so this attempt will fail at once."
    },
    "retried": "Charge retried: {{status}}.",
    "loadError": "Could not load billing.",
    "errors": {
      "notRetryable": "This charge can't be retried now.",
      "notFound": "This charge couldn't be found. The list has been reloaded.",
      "concurrent": "The charge was being updated at the same time. Try again.",
      "retry": "Couldn't retry the charge."
    },
    "retryFailed": "The retry didn't go through: {{failure}}",
    "noFailureReason": "No failure reason given"
  },
  "commissionPlans": {
    "title": "Commission plans",
    "help": {
      "short": "Resellers design their own affiliate commission plans; there are no platform plans.",
      "body": "An affiliate keeps its assigned plan, and each referral keeps the plan it was made under, for life. Changes here are made on the reseller’s behalf and audited as you.",
      "schedule": "Month 1 is the referral's first paid month; trials don't count.",
      "coolOff": "Commission is held this long after each payment and voided if the payment is refunded in that time. Longer is safer; shorter is more attractive.",
      "afterEnd": "What happens to commission on existing referrals once the affiliate ends."
    },
    "actions": {
      "new": "New commission plan",
      "edit": "Edit…",
      "fix": "Fix this plan",
      "saveDraft": "Save draft",
      "check": "Check",
      "onThisPlan": "Affiliates on this plan"
    },
    "assigned": {
      "title": "Assigned to",
      "empty": "No affiliates are on this plan.",
      "affiliate": "Affiliate",
      "tenant": "Tenant",
      "status": "Status",
      "tableAria": "Affiliates assigned to {{name}}",
      "loadError": "Could not load affiliates."
    },
    "limits": "Limits from {{card}}: recurring up to {{pct}}, cool-off up to {{days, number}} days.",
    "limitsError": "Couldn't load the limits from the adopted rate card.",
    "noAgreement": "This reseller needs an agreement before it can have commission plans.",
    "openAgreement": "Open the Agreement tab",
    "empty": "No commission plans yet.",
    "tableAria": "The reseller's commission plans",
    "loadError": "Couldn't load this reseller's commission plans.",
    "col": {
      "name": "Name",
      "mode": "Mode",
      "terms": "Terms",
      "appliesTo": "Applies to",
      "coolOff": "Cool-off",
      "afterEnd": "After end",
      "status": "Status",
      "actions": "Actions"
    },
    "collapse": "Collapse {{name}}",
    "expand": "Expand {{name}}",
    "mode": {
      "SIMPLE": "Simple",
      "ADVANCED": "Advanced"
    },
    "appliesTo": {
      "BASE": "Base price",
      "ALL": "All lines"
    },
    "afterEnd": {
      "STOP": "Stop",
      "HONOR": "Honor"
    },
    "terms": {
      "life": "{{rate}} for life",
      "oneMonth": "{{rate}} for 1 month",
      "months_one": "{{rate}} for {{count, number}} month",
      "months_other": "{{rate}} for {{count, number}} months",
      "phases_one": "{{count, number}} phase: {{rates}}",
      "phases_other": "{{count, number}} phases: {{rates}}",
      "bounty": "{{amount}} on payment {{n, number}}",
      "milestones_one": "{{count, number}} milestone",
      "milestones_other": "{{count, number}} milestones",
      "perReferralCap": "Per referral at most {{amount}}",
      "perAffiliateMonthCap": "Per affiliate per month at most {{amount}}"
    },
    "noncompliant": {
      "explanation": "Over a limit since {{date}}. It can't be assigned to more affiliates; affiliates on it keep it."
    },
    "activate": {
      "confirm": "Activate {{name}}? An active plan can't be edited; copy it to change it.",
      "title": "Activate {{name}}?"
    },
    "close": {
      "confirm": "Close {{name}}? No more affiliates can be given it; affiliates on it keep it.",
      "title": "Close {{name}}?"
    },
    "toast": {
      "created": "{{name}} is a new draft. Edit it, then activate it.",
      "copied": "{{name}} is a new draft. Edit it, then activate it.",
      "activated": "Plan activated. Affiliates can now be given it.",
      "closed": "{{name}} is closed. Affiliates on it keep it.",
      "saved": "{{name}} saved. Activate it when it’s ready."
    },
    "errors": {
      "immutable": "This plan is no longer a draft. Copy it to change it.",
      "nameTaken": "Another of this reseller's plans is called \"{{name}}\".",
      "overLimit": "This plan is over a limit. Edit it to fix it.",
      "create": "Couldn't create the commission plan.",
      "copy": "Couldn't copy the commission plan.",
      "activate": "Couldn't activate the commission plan.",
      "close": "Couldn't close the commission plan.",
      "save": "Couldn't save the commission plan."
    },
    "detail": {
      "phasesAria": "Phases of {{name}}",
      "currency": "Currency",
      "created": "Created",
      "activated": "Activated",
      "closed": "Closed",
      "noncompliantSince": "Over a limit since",
      "fromMonth": "From month",
      "toMonth": "To month",
      "rate": "Rate",
      "onward": "Onward",
      "bounty": "Bounty",
      "onPayment": "on payment {{n, number}}",
      "none": "None",
      "noCap": "No cap",
      "perReferralCap": "Per referral",
      "perAffiliateMonthCap": "Per affiliate per month",
      "milestones": "Milestones",
      "milestonesAria": "Milestones of {{name}}",
      "qualifiedReferrals": "Qualified referrals",
      "bonus": "Bonus"
    },
    "form": {
      "loadError": "Couldn't load this commission plan.",
      "title": "Edit {{name}}",
      "loadingTitle": "Commission plan",
      "notDraft": "Only a draft plan can be edited. Copy it to make changes.",
      "rate": "Rate (%)",
      "months": "Number of months",
      "schedule": "Schedule",
      "phaseRate": "Phase {{n, number}} rate (%)",
      "phaseTo": "Phase {{n, number}} to month",
      "phaseFrom": "Phase {{n, number}} from month",
      "name": "Name",
      "mode": "Mode",
      "appliesTo": "Applies to",
      "coolOff": "Cool-off (days)",
      "afterEnd": "After the affiliate ends",
      "rateRange": "Enter a rate from 0 to 100.",
      "nameRequired": "Name is required.",
      "nameLong": "Use at most {{max, number}} characters.",
      "monthsRange": "Enter a whole number of months, 1 or more.",
      "onlyLastOpen": "Only the last phase may be onward.",
      "toRange": "Enter a month from {{from, number}} on.",
      "coolOffRange": "Enter a whole number from 0 to {{max, number}}.",
      "fixedFrom": "Copied from {{name}}. Bring it within the limits, activate it, then move affiliates onto it.",
      "warnMargin": "A recurring rate never pays more than the reseller's margin on that line. Priced at our wholesale, recurring commission is 0.",
      "warnAnnual": "Annual subscriptions are commissioned at the phase of the payment date, on the whole annual amount.",
      "section": {
        "plan": "Plan",
        "terms": "Terms",
        "advanced": "Bounty, milestones and caps"
      },
      "simpleBlocked": "Remove the extra phases first",
      "simpleBlockedEconomics": "Remove the bounty, milestones and caps first",
      "leaveEmpty": "Leave it empty for none",
      "appliesToBase": "The subscription price only.",
      "appliesToAll": "Base, seats, connected accounts and AI (never tax).",
      "afterEndStop": "Nothing more is earned after the affiliate's end date.",
      "afterEndHonor": "Existing referrals keep earning.",
      "duration": "Duration",
      "forMonths": "For a number of months",
      "forLife": "For life",
      "phases": "Phases",
      "rowActions": "Remove",
      "removePhase": "Remove phase {{n, number}}",
      "addPhase": "Add phase",
      "bounty": "Bounty",
      "bountyOnPayment": "Paid on the referral's payment no.",
      "bountyHelp": "A one-time amount, paid when the referral makes that many base payments, after the cool-off. Voided if a payment is refunded before then.",
      "bountyOnPaymentRange": "Enter a whole number from 1 to {{max, number}}.",
      "milestones": "Milestones",
      "milestonesHelp": "Paid once each when the affiliate's count of qualified referrals (paid, past cool-off, still subscribed) first reaches the number, at the reseller's month-end.",
      "milestoneQualified": "Milestone {{n, number}} qualified referrals",
      "milestoneBonus": "Milestone {{n, number}} bonus",
      "qualifiedRange": "Enter a whole number, 1 or more.",
      "amountInvalid": "Enter an amount.",
      "addMilestone": "Add milestone",
      "removeMilestone": "Remove milestone {{n, number}}",
      "perReferralCap": "Per referral, at most",
      "perReferralCapHelp": "The most one referral can ever earn the affiliate.",
      "perAffiliateMonthCap": "Per affiliate per month, at most",
      "perAffiliateMonthCapHelp": "The most one affiliate can earn from you in a month.",
      "noCap": "No cap",
      "upTo": "Up to {{amount}}.",
      "eachUpTo": "Each up to {{amount}}.",
      "warnNotLimited": "Bounties and milestones aren't limited by margin. They're charged in the reseller's monthly settlement, and a negative month is charged to the reseller's card."
    },
    "preview": {
      "title": "Check against the limits",
      "cardsError": "Couldn't load rate cards.",
      "card": "Rate card for the example",
      "error": "Couldn't check the plan.",
      "noCard": "Add a rate card for this reseller to see an example.",
      "loadingCards": "Loading rate cards…",
      "fixFields": "Fix the highlighted fields to check this plan.",
      "checking": "Checking…",
      "empty": "Change a field or choose Check to see whether the plan is within the limits and what it pays.",
      "valid": "This plan is within the limits.",
      "invalid": "This plan breaks a limit or a schedule rule. Each field that does says why.",
      "noExample": "Fix the schedule to see an example.",
      "exampleAria": "Example by month",
      "exampleTitle": "One subscriber at {{amount}} a month on {{card}}",
      "exampleCaption": "Paid months 1–24, the first collected today. Payable after a {{days, number}}-day cool-off.",
      "col": {
        "month": "Month",
        "collected": "Collected",
        "rate": "Rate",
        "commission": "Commission",
        "marginBefore": "Reseller margin before",
        "marginAfter": "Reseller margin after",
        "payableOn": "Payable on",
        "bounty": "Bounty",
        "capped": "Capped"
      },
      "capped": "Capped"
    }
  },
  "affiliates": {
    "tabs": {
      "aria": "Affiliate sections"
    },
    "absent": "—",
    "filter": {
      "all": "All"
    },
    "list": {
      "title": "Affiliates",
      "help": "Affiliates belong to this tenant and are managed by its reseller. You can view them, and pause or end one for cause.",
      "aria": "Affiliates",
      "empty": "No affiliates yet.",
      "filteredEmpty": "No affiliates match this filter.",
      "loadError": "Could not load affiliates.",
      "filterAria": "Affiliate status"
    },
    "col": {
      "name": "Name",
      "email": "Email",
      "status": "Status",
      "plan": "Plan",
      "referredActive": "Referred active",
      "last30": "Last 30 days",
      "subscriber": "Subscriber",
      "offer": "Offer",
      "since": "Since",
      "firstPaid": "First paid",
      "thisPeriod": "This period",
      "code": "Code",
      "label": "Label",
      "link": "Link",
      "week": "Week",
      "signups": "Sign-ups",
      "currency": "Currency",
      "revenue30": "Referred revenue, 30 days",
      "revenueToDate": "Referred revenue, to date",
      "commission30": "Commission, 30 days",
      "commissionToDate": "Commission, to date",
      "effective": "Effective",
      "ended": "Ended",
      "cadence": "Cadence",
      "minimum": "Minimum payout",
      "method": "Method",
      "taxDocs": "Tax documents"
    },
    "status": {
      "APPLIED": "Applied",
      "ACTIVE": "Active",
      "PAUSED": "Paused",
      "ENDED": "Ended"
    },
    "referralStatus": {
      "ACTIVE": "Active",
      "ENDED": "Ended",
      "SUPERSEDED": "Superseded",
      "VOIDED": "Voided"
    },
    "codeStatus": {
      "ACTIVE": "Active",
      "PAUSED": "Paused"
    },
    "plan": {
      "noAgreement": "No agreement",
      "fallback": "Plan #{{id}}",
      "noncompliant": "Over a limit. It can't be assigned to more affiliates; affiliates on it keep it."
    },
    "last30": {
      "revenue": "revenue",
      "commission": "commission"
    },
    "held": {
      "chip": "Held for review"
    },
    "page": {
      "notFound": "Affiliate not found",
      "loadError": "Could not load this affiliate.",
      "copyId": "Copy ID {{id}}"
    },
    "dates": {
      "applied": "Applied {{date}}",
      "approved": "Approved {{date}}",
      "ended": "Ended {{date}}",
      "effective": "Effective {{date}}",
      "endedOn": "Ended {{date}}"
    },
    "stateChanged": "This affiliate's status changed",
    "pause": {
      "action": "Pause",
      "title": "Pause {{name}}?",
      "words": "New referrals stop being attributed; existing ones keep earning.",
      "confirm": "Pause",
      "failed": "Could not pause this affiliate."
    },
    "resume": {
      "action": "Resume",
      "title": "Resume {{name}}?",
      "words": "New referrals can be attributed again.",
      "confirm": "Resume",
      "failed": "Could not resume this affiliate."
    },
    "end": {
      "action": "End for cause…",
      "title": "End {{name}} for cause",
      "words": "Ending here stops all earning and holds unpaid commission for review. It can't be undone.",
      "confirm": "End for cause",
      "failed": "Could not end this affiliate."
    },
    "release": {
      "action": "Release hold…",
      "title": "Release hold",
      "words": "Release {{name}}'s unpaid commission for payout?",
      "confirm": "Release hold",
      "row": "Release hold for {{name}}",
      "done": "Hold released. Unpaid statements can be paid.",
      "failed": "Could not release the hold."
    },
    "reason": {
      "label": "Reason",
      "length": "Use 3 to 500 characters."
    },
    "hold": {
      "alert": "Payouts held for review since {{date}}: {{reason}} (by {{by}})"
    },
    "performance": {
      "title": "Performance",
      "aria": "Referred revenue and commission by currency",
      "empty": "No referred revenue yet.",
      "summary_one": "{{active, number}} of {{count, number}} referred subscriber",
      "summary_other": "{{active, number}} of {{count, number}} referred subscribers"
    },
    "earnings": {
      "title": "Earnings",
      "aria": "Earnings by month in {{currency}}",
      "empty": "No earnings yet.",
      "loadError": "Could not load earnings.",
      "col": {
        "month": "Month",
        "recurring": "Recurring",
        "bounty": "Bounty",
        "milestone": "Milestone",
        "pending": "Pending",
        "payable": "Payable",
        "voided": "Voided",
        "clawedBack": "Clawed back",
        "recovered": "Recovered"
      }
    },
    "signups": {
      "title": "Weekly sign-ups",
      "aria": "Weekly sign-ups",
      "empty": "No weekly sign-ups yet."
    },
    "agreement": {
      "title": "Agreement",
      "none": "No agreement",
      "history": "History",
      "historyAria": "Agreement history",
      "loadError": "Could not load the agreement.",
      "inForceAria": "Agreement in force"
    },
    "referrals": {
      "title": "Referrals",
      "aria": "Referrals",
      "empty": "No referrals yet.",
      "filteredEmpty": "No referrals match this filter.",
      "loadError": "Could not load referrals.",
      "filterAria": "Referral status",
      "notYetPaid": "Not yet paid"
    },
    "codes": {
      "title": "Codes",
      "aria": "Codes",
      "empty": "No codes yet.",
      "loadError": "Could not load codes.",
      "copy": "Copy link for {{code}}"
    }
  },
  "partners": {
    "singular": "Partner",
    "new": "New partner…",
    "subtitle": "Partners and their businesses, together in one place.",
    "search": "Search partners",
    "searchPlaceholder": "Search partner or slug",
    "searchHint": "Searches partner name and slug",
    "empty": "No partners yet.",
    "emptySearch": "No partners match your search.",
    "noTenant": "No tenant yet",
    "canSell": "Can sell",
    "createTenant": "Create tenant…",
    "createTenantSuspended": "This partner is suspended. Reactivate it before creating its tenant.",
    "createTenantDeactivated": "This partner is deactivated.",
    "createTenantHasTenant": "This partner already has a tenant.",
    "notFound": "Partner not found",
    "loadingTitle": "Partner",
    "resolveError": "Could not find this partner.",
    "tenantIdentity": "Tenant: {{name}} ({{slug}})",
    "perMonth": "per month",
    "step1": "Step 1 of 2 — Create partner",
    "step2": "Step 2 of 2 — Create tenant",
    "tenantFailed": "Partner created. Could not confirm tenant creation. Check the partner page before trying again.",
    "paletteFailed": "Couldn't search partners — try again",
    "searchList": "Search the Partners list",
    "scopeAll": "All partners",
    "scope": "Partner: {{name}}",
    "number": "Partner #{{id}}",
    "sectionsAria": "Partner sections",
    "partnerAdministrators": {
      "caption": "Sign in to the reseller console to manage this partner."
    },
    "tenantAdministrators": {
      "caption": "Sign in to the tenant's app to run the business."
    },
    "section": {
      "overview": "Overview",
      "reports": "Reports",
      "settings": "Settings"
    },
    "caption": {
      "overview": "What needs you, and how is this partner doing?",
      "reports": "What's happening, over time.",
      "settings": "How this partner is set up."
    },
    "tab": {
      "overview": "Overview",
      "agreement": "Agreement",
      "standing": "Standing",
      "billing": "Charges",
      "settlements": "Settlements",
      "priceCard": "Rate card",
      "offers": "Offers",
      "promotions": "Promotions",
      "addons": "Add-ons",
      "subscriptions": "Subscriptions",
      "statements": "Statements",
      "seats": "Seats",
      "aiUsage": "AI usage",
      "revenue": "Revenue",
      "deletions": "Deletions",
      "affiliates": "Affiliates",
      "commissionPlans": "Commission plans",
      "affiliatePayouts": "Affiliate payouts",
      "partnerAdministrators": "Partner administrators",
      "tenantAdministrators": "Tenant administrators",
      "customers": "Customers",
      "domain": "Domain",
      "ghl": "GHL connection",
      "payments": "Payments",
      "details": "Details and brand",
      "cardOnFile": "Card on file",
      "ledger": "Balance and holds",
      "notices": "Notices sent",
      "ledgerStatements": "Statements",
      "ledgerUnassigned": "Unassigned lines"
    },
    "sellableReason": {
      "NO_RESELLER": "No reseller",
      "NO_AGREEMENT": "No agreement",
      "NO_RATE_CARD": "No rate card",
      "CURRENCY_NOT_PRICED": "Currency not priced"
    },
    "searching": "Searching partners",
    "platformManaged": {
      "chip": "Platform-managed",
      "alert": "Platform-managed since {{date}}. Settlements are retained; reactivate to resume payouts."
    },
    "house": {
      "chip": "House",
      "mark": "Mark as house partner…",
      "unmark": "Unmark as house partner…",
      "markTitle": "Mark {{partner}} as the house partner?",
      "unmarkTitle": "Unmark {{partner}} as the house partner?",
      "consequence": "The house partner is ours: it's never evaluated or deactivated.",
      "error": "Could not change the house flag.",
      "standingConflict": "A partner under deactivation can't be marked as house. Reactivate it first."
    },
    "creationWarning": {
      "openPayments": "Open Payments"
    },
    "group": {
      "standing": "Standing",
      "money": "Money",
      "subscribers": "Subscribers",
      "affiliates": "Affiliates",
      "terms": "Terms",
      "pricing": "Pricing",
      "profile": "Profile",
      "access": "Access",
      "connections": "Connections"
    },
    "needsYou": {
      "title": "Needs you",
      "caption": "Things blocking this partner now. Each one opens where it's fixed.",
      "empty": "Nothing needs you right now.",
      "checking": "Checking what needs you…",
      "count_one": ", {{count, number}} needs you",
      "count_other": ", {{count, number}} need you",
      "dot": " — needs you",
      "openAgreement": "Open agreement",
      "openCharges": "Open charges",
      "launch": {
        "title": "Official launch not set",
        "body": "No month is checked against the minimum until a launch month is set."
      },
      "charges": {
        "title_one": "{{count, number}} charge can be retried",
        "title_other": "{{count, number}} charges can be retried",
        "body": "A charge to this partner's card failed. You can try it again.",
        "loadError": "Couldn't check this partner's charges."
      }
    },
    "atAGlance": {
      "title": "At a glance",
      "caption": "Read-only. Open a card to see its report."
    }
  },
  "aiReconciliation": {
    "from": "From (UTC)",
    "to": "To (UTC)",
    "range": {
      "order": "The start must be on or before the end.",
      "tooLong": "Choose at most 366 days.",
      "refused": "These dates can't be shown. Choose at most 366 days, with the start on or before the end."
    },
    "loadError": "Could not load the AI cost reconciliation.",
    "empty": "No reconciliation rows for these days.",
    "regionAria": "AI cost reconciliation table",
    "tableAria": "AI cost reconciliation",
    "mustBeZero": "must be 0",
    "shouldBeZero": "should be 0",
    "legend": "† Must be 0.",
    "breached": "Breached",
    "col": {
      "day": "Day",
      "currency": "Currency",
      "sent": "Sent",
      "settledActual": "Settled at usage",
      "settledAtHold": "Settled at the hold",
      "holdExpiredCharged": "Hold expired, charged",
      "providerRejected": "Provider rejected",
      "providerRejectedAuth": "Rejected: auth",
      "releasedAfterSend": "Released after send",
      "costOverHold": "Cost over the hold",
      "sentUnsettled": "Sent, unsettled",
      "providerCost": "Provider cost",
      "customerUsage": "Customer usage",
      "platformCost": "Platform-paid cost",
      "reconciledAt": "Reconciled at",
      "truncated": "Truncated",
      "refused": "Refused"
    },
    "help": {
      "truncated": "Answers cut off at the token limit. Charged at their usage.",
      "refused": "Requests the model refused."
    }
  },
  "cardSettings": {
    "controls": {
      "title": "Controls",
      "maxAiSpend": "Maximum AI spend per person per month",
      "maxAiSpendHelp": "The most one person can spend on AI in a month. A person's own lower limit still applies.",
      "aiDailyCap": "Daily AI cap",
      "aiDailyCapHelp": "The most AI calls one person can make in a day.",
      "aiMaxInflight": "AI calls at once",
      "aiMaxInflightHelp": "How many AI calls one person can have running at the same time.",
      "autoRecharges": "Automatic recharges per 30 days",
      "autoRechargesHelp": "0 means the wallet never recharges itself; the person tops up by hand.",
      "graceDays": "Grace days after a subscription ends",
      "graceDaysHelp": "Read when grace starts. A subscription already in grace keeps its end date.",
      "reviewSuggested": "This card isn't in USD and still has the starting maximum AI spend. Check it and schedule the right amount.",
      "affiliateRecurringMax": "Highest affiliate recurring rate",
      "affiliateRecurringMaxHelp": "The highest rate in any phase of a reseller's commission plan. Checked when a plan is created or activated; active plans aren't changed.",
      "affiliateBountyMax": "Highest affiliate bounty",
      "affiliateBountyMaxHelp": "The largest one-time bounty a commission plan may offer per referral.",
      "affiliateMilestoneMax": "Highest milestone bonus",
      "affiliateMilestoneMaxHelp": "The largest single milestone bonus a commission plan may offer.",
      "affiliateCoolOffMax": "Longest affiliate cool-off",
      "affiliateCoolOffMaxHelp": "The longest cool-off, in days, a commission plan may set."
    }
  },
  "platformAiControls": {
    "title": "Platform AI controls",
    "help": "The domain helper's AI is paid by the platform. These caps limit it.",
    "resellerDaily": "Domain-setup AI calls per reseller per day",
    "platformDaily": "Domain-setup AI calls across the platform per day"
  },
  "datedSettings": {
    "current": "Current",
    "inEffectSince": "In effect since {{when}}",
    "setBy": "Set by {{who}}",
    "noteLine": "Note: {{note}}",
    "scheduled": "Scheduled",
    "noneScheduled": "No changes scheduled.",
    "scheduledAria": "{{title}}: scheduled changes",
    "history": "History",
    "noHistory": "No earlier settings.",
    "historyAria": "{{title}}: history",
    "withdraw": "Withdraw…",
    "withdrawRow": "Withdraw the change starting {{when}}",
    "withdrawn": "Withdrawn",
    "withdrawnBy": "by {{who}}",
    "past": "Past",
    "schedule": "Schedule a change…",
    "scheduleTitle": "Schedule a change: {{title}}",
    "withdrawTitle": "Withdraw a scheduled change",
    "withdrawConsequence": "Withdraw the change starting {{when}}?",
    "withdrawConfirm": "Withdraw",
    "form": {
      "required": "Required.",
      "tooLong": "Use at most {{max, number}} characters.",
      "between": "Must be between {{min, number}} and {{max, number}}.",
      "atLeast": "Must be at least {{min, number}}.",
      "atMost": "Must be at most {{max, number}}.",
      "number": "Enter a number.",
      "whole": "Must be a whole number.",
      "whenRequired": "Choose a date and a time.",
      "when": "When",
      "now": "Now",
      "at": "From a date and time",
      "date": "Date (UTC)",
      "time": "Time (UTC)",
      "note": "Note (optional)",
      "submit": "Schedule"
    },
    "errors": {
      "taken": "Another change already starts at that time. Pick another time.",
      "future": "Must be in the future. Pick Now to apply it straight away.",
      "notLater": "Choose a time after now (UTC), or pick Now.",
      "schedule": "Couldn't schedule this change.",
      "notFound": "That setting couldn't be found.",
      "inEffect": "This change is already in effect, so it can't be withdrawn. The list has been reloaded.",
      "rowInForce": "This setting is already in force and can't be withdrawn. Schedule a new value instead.",
      "lastRow": "This is the only setting row, so it can't be withdrawn.",
      "withdraw": "Couldn't withdraw this change."
    },
    "loadError": "Could not load these settings.",
    "col": {
      "starts": "Starts",
      "setBy": "Set by",
      "note": "Note",
      "actions": "Actions",
      "status": "Status"
    }
  },
  "rateCard": {
    "prices": {
      "readOnly": "A published version is read-only. Use New version… to change its prices.",
      "editTitle": "Prices of version {{version, number}}",
      "ourCost": "Our cost",
      "wholesale": "Wholesale",
      "retail": "Retail",
      "annualWholesale": "Wholesale per year",
      "annualRetail": "Retail per year",
      "guestsIncluded": "Guests included",
      "perGuestCost": "Our cost per guest",
      "perGuestWholesale": "Wholesale per guest",
      "perGuestRetail": "Retail per guest",
      "connectionsIncluded": "Bank connections included",
      "perConnectionCost": "Our cost per connection",
      "perConnectionWholesale": "Wholesale per connection",
      "perConnectionRetail": "Retail per connection",
      "aiWholesaleMarkup": "Wholesale markup on provider cost (%)",
      "aiRetailMarkup": "Retail markup on wholesale (%)",
      "creditAtCost": "Monthly AI credit, at our cost",
      "creditAtRetail": "Monthly AI credit, at the customer price",
      "creditShare": "Share of the credit we absorb (%)",
      "rechargeAmount": "Wallet recharge amount",
      "help": {
        "ourCost": "What one subscriber costs us each month. Only the product admin sees it; a loss is allowed and shows on the worksheet.",
        "wholesale": "What the reseller pays us each month for one subscriber.",
        "retail": "What the customer pays each month.",
        "annualWholesale": "What the reseller pays us for a year's plan.",
        "annualRetail": "What the customer pays for a year. Leave empty to offer monthly only.",
        "included": "How many are free to the customer and to the reseller. We carry their cost.",
        "unitCost": "What each one costs us, included or not.",
        "unitWholesale": "What the reseller pays us for each one after the included count.",
        "unitRetail": "What the customer pays for each one after the included count.",
        "aiWholesaleMarkup": "Our markup on the AI provider's cost: the reseller's AI price.",
        "aiRetailMarkup": "The markup on the wholesale AI price: the customer's AI price.",
        "credit": "AI the customer gets each month. Set it at the customer price or by what it costs us; we convert our cost with the markups and store the customer price.",
        "creditShare": "How much of the credit we absorb. The reseller absorbs the rest."
      },
      "tiered": "This version has tiered bands. They are shown read-only and saving keeps them as they are.",
      "section": {
        "base": "Base, per month",
        "annual": "Base, per year",
        "guests": "Guests",
        "connections": "Bank connections"
      },
      "annualCostNote": "Our annual cost is the monthly cost × 12; the worksheet uses it.",
      "creditBy": "Set the monthly credit by",
      "creditByRetail": "Customer price",
      "creditByCost": "Our cost",
      "creditCostCaption": "We convert our cost with the markups above. Saved now: {{amount}} at the customer price.",
      "creditRetailCaption": "The credit at the customer price.",
      "bandsAria": "Bands",
      "bandFrom": "From",
      "bandTo": "To",
      "bandRetail": "Retail flat + per unit",
      "bandWholesale": "Wholesale flat + per unit",
      "bandCost": "Our cost flat + per unit",
      "bandOpen": "and up",
      "summaryAria": "Prices",
      "line": "Line",
      "aiSummary": "AI: wholesale markup {{wholesale}} on provider cost, retail markup {{retail}} on wholesale. Monthly credit {{credit}} at the customer price; we absorb {{share}}.",
      "rule": {
        "notNegative": "Must be zero or greater.",
        "checkBand": "Check this band's prices.",
        "wholesale": "Must be above zero and at most the retail price.",
        "aboveZero": "Must be more than zero."
      }
    },
    "grid": {
      "perGuestOver": "Per guest over {{n, number}}",
      "perConnectionOver": "Per connection over {{n, number}}",
      "monthly": "Monthly",
      "annual": "Annual"
    },
    "singular": "Rate card",
    "notFound": "That rate card couldn't be found.",
    "loadError": "Could not load this rate card.",
    "draftOnly": "draft",
    "actions": {
      "publishVersion": "Publish version {{version, number}}…",
      "worksheet": "Worksheet",
      "editPrices": "Edit prices…"
    },
    "tabs": {
      "aria": "Rate card sections",
      "worksheet": "Worksheet",
      "prices": "Prices",
      "resellers": "Resellers"
    },
    "versionPicker": "Version",
    "publishRefused": "Version {{version, number}} can't be published yet. Fix the marked prices, save the draft, then publish.",
    "publishRefusedOther": "Some of the checks that failed have no field on this page.",
    "toast": {
      "saved": "Prices saved."
    },
    "grant": {
      "error": "Couldn't grant this rate card."
    },
    "resellers": {
      "adoptHint": "A reseller adopts a granted card on its partner page."
    },
    "list": {
      "subtitle": "Each card holds our cost, wholesale and retail. Grant it to resellers; each reseller adopts one.",
      "filterAria": "Rate card status",
      "filter": {
        "active": "Active",
        "drafts": "Drafts",
        "all": "All"
      },
      "search": "Search by name",
      "loadError": "Could not load rate cards.",
      "filteredEmpty": "No rate cards match. Try All, or another name.",
      "add": "Add new rate card",
      "cardLink": "{{name}}, {{currency}} · {{versionLabel}}",
      "notGranted": "Not granted yet",
      "resellers": "{{granted, number}} granted, {{adopted, number}} adopted",
      "pillAdopted": "{{name}} (adopted)",
      "pillGranted": "{{name}}"
    },
    "create": {
      "nameClash": "Another rate card has this name.",
      "error": "Couldn't create the rate card.",
      "hint": "The first draft opens on Prices, where you set our cost, wholesale and retail.",
      "setControls": "Set the controls now",
      "controlsOn": "Prefilled with the standard values. A field left empty takes the standard value.",
      "controlsOff": "The card starts with the standard controls. You can schedule a change on its Controls tab."
    },
    "worksheet": {
      "subscriber": "A hypothetical subscriber",
      "mode": "Billing mode",
      "monthly": "Monthly",
      "annual": "Annual",
      "noAnnual": "This version has no annual price.",
      "guests": "Guests",
      "countRange": "A whole number from 0 to 50.",
      "connections": "Bank accounts connected",
      "aiUsed": "AI used per month (customer price)",
      "updating": "Updating the worksheet",
      "loadError": "Couldn't work out this worksheet.",
      "fixInputs": "Fix the inputs to see the worksheet.",
      "billYearly": "The customer's bill (billed yearly)",
      "billMonthly": "The customer's bill (billed monthly)",
      "billAria": "The customer's bill",
      "col": {
        "line": "Line",
        "quantity": "Qty",
        "amount": "Amount",
        "unitPrice": "Unit price"
      },
      "line": {
        "BASE": "Base",
        "GUESTS": "Guests",
        "CONNECTIONS": "Bank connections",
        "SUBSCRIPTION_PROCESSING": "Card processing on the subscription",
        "AI_PAID": "AI the customer pays for",
        "AI_CREDIT": "AI covered by the credit",
        "RECHARGE_PROCESSING": "Card processing on recharges",
        "TOTAL": "Total"
      },
      "charge": {
        "BASE": "Base plan",
        "ADD_ONS": "Guests and connections",
        "RECHARGE": "Wallet recharge"
      },
      "steps": "How it's worked out",
      "chargesPerYear": "Subscription charges a year: {{n, number}}.",
      "chargeLine": "{{kind}}: {{gross}} charged {{perYear, number}} times a year. Card fee {{fee}}: the reseller pays {{reseller}}, we pay {{platform}}.",
      "noRate": "No card processing rate is set for {{currency}}, so no fee is counted.",
      "rate": "Card processing: {{percent}} + {{fixed}} per charge.",
      "recharges": "Automatic wallet recharges a month: {{n, number}}.",
      "creditCost": "The monthly AI credit costs us {{amount}}.",
      "customerPays": "Customer pays",
      "resellerProfit": "Reseller profit",
      "ourProfit": "Our profit",
      "profitPercent": "{{percent}} of what the customer pays",
      "earningsAnnual": "Who earns what, per month (the annual plan ÷ 12)",
      "earnings": "Who earns what, per month",
      "earningsAria": "Who earns what, by line",
      "resellerCosts": "Reseller costs",
      "ourCost": "Our cost",
      "note": "Reseller profit = customer pays + reseller costs. Our profit = the wholesale the reseller pays us + our cost. Affiliate commission comes out of the reseller's profit.",
      "bill": {
        "BASE": "Base subscription",
        "BASE_YEAR": "Base subscription, 1 year",
        "GUESTS": "Guests",
        "GUESTS_YEAR": "Guests, 12 months",
        "CONNECTIONS": "Bank connections",
        "CONNECTIONS_YEAR": "Bank connections, 12 months",
        "AI_USAGE": "AI usage this month (wallet)",
        "AI_CREDIT": "Monthly AI credit",
        "flatAndUnit": "{{flat}} + {{unit}} each",
        "subtotalMonth": "Subscription, per month",
        "subtotalYear": "Subscription, per year",
        "aiNet": "AI paid from the wallet, per month"
      }
    },
    "status": {
      "active": "Active",
      "closed": "Closed",
      "draft": "Draft"
    },
    "searchFailed": "Couldn't search rate cards — try again",
    "searching": "Searching rate cards",
    "publishRefusedNoField": "Version {{version, number}} can't be published yet.",
    "violations": {
      "summary_one": "This version has {{count, number}} problem; publishing will be refused until it's fixed.",
      "summary_other": "This version has {{count, number}} problems; publishing will be refused until they're fixed.",
      "chip_one": "{{count, number}} problem",
      "chip_other": "{{count, number}} problems",
      "item": "{{label}}: {{message}}",
      "band": "{{section}}, band {{n, number}}",
      "other": "Another price on this version",
      "summaryPublished_one": "This version breaks {{count, number}} publishing rule. It keeps selling; fix it in a new version.",
      "summaryPublished_other": "This version breaks {{count, number}} publishing rules. It keeps selling; fix them in a new version.",
      "checkValue": "Check this value."
    }
  },
  "ledger": {
    "title": "Ledger",
    "notAvailable": "The partner ledger isn't available yet.",
    "loadError": "Couldn't load the ledger.",
    "payeeLoadError": "Couldn't read this partner's payee.",
    "noPayee": "This partner isn't set up as a payee yet.",
    "noPayeeLink": "See the payee status",
    "loadMore": "Load more",
    "currency": "Currency",
    "amount": {
      "label": "Amount",
      "invalid": "Enter an amount above zero, with no more decimals than the currency has."
    },
    "reason": {
      "label": "Reason",
      "help": "Recorded in the audit log.",
      "length": "Use 3 to 500 characters."
    },
    "summary": {
      "title": "Balance and holds",
      "balance": "Balance:"
    },
    "holds": {
      "title": "Open holds",
      "none": "No open holds.",
      "overCap": "over the cap",
      "since": "since {{date}}"
    },
    "last": {
      "title": "Last statement",
      "none": "No statement has closed yet."
    },
    "statements": {
      "title": "Statements",
      "empty": "No statements yet.",
      "loadError": "Couldn't load the statements.",
      "open": "Open statement",
      "openRow": "Open the {{period}} statement",
      "col": {
        "period": "Period",
        "status": "Status",
        "opening": "Opening",
        "lines": "Lines",
        "closing": "Closing",
        "paid": "Paid on",
        "actions": "Actions"
      }
    },
    "statement": {
      "title": "Statement for {{period}}",
      "titleLoading": "Statement",
      "notFound": "This statement isn't available.",
      "loadError": "Couldn't load the statement.",
      "paidOn": "Paid on {{date}}",
      "noLines": "No lines on this statement.",
      "close": "Close statement"
    },
    "unassigned": {
      "title": "Unassigned lines",
      "help": "Lines no statement has taken yet. The next statement takes them.",
      "empty": "No unassigned lines."
    },
    "lines": {
      "loadError": "Couldn't load the lines.",
      "col": {
        "date": "Date",
        "kind": "Kind",
        "description": "Description",
        "amount": "Amount"
      },
      "reverses": "Reverses line {{id}}"
    },
    "statementStatus": {
      "CARRIED": "Carried",
      "HELD": "Held",
      "NEGATIVE": "Negative",
      "PAYABLE": "Payable",
      "PAYOUT_FAILED": "Payout failed",
      "COLLECTING": "Collecting",
      "PAYING": "Paying",
      "PAID": "Paid",
      "PAID_EXTERNALLY": "Paid externally",
      "COLLECTED": "Collected",
      "SETTLED": "Settled"
    },
    "holdKind": {
      "FOR_CAUSE": "For cause",
      "REVIEW": "Review",
      "TAX_ID_UNVERIFIED": "Tax ID unverified",
      "PAYOUT_RETURNED": "Payout returned",
      "OTHER": "Other: {{kind}}",
      "COLLECTION_CONFLICT": "Collection conflict"
    },
    "lineKind": {
      "REVENUE_SHARE": "Revenue share",
      "MARGIN": "Margin",
      "AFFILIATE_COMMISSION": "Affiliate commission",
      "COMMISSION_DEDUCTION": "Commission deduction",
      "PROCESSING_FEE": "Processing fee",
      "AFFILIATE_BONUS": "Affiliate bonus",
      "MINIMUM_SHORTFALL": "Minimum shortfall",
      "ADJUSTMENT": "Adjustment",
      "REVERSAL": "Reversal",
      "VOID": "Void",
      "PAYOUT": "Payout",
      "PAYOUT_MANUAL": "Manual payment",
      "PAYOUT_RETURNED": "Payout returned",
      "COLLECTION": "Collection"
    },
    "mode": {
      "OFF": "Off",
      "SHADOW": "Shadow",
      "LIVE": "Live"
    },
    "hold": {
      "action": "Hold for cause…",
      "title": "Hold {{name}}'s payouts for cause?",
      "words": "No payout runs while the hold is open, and statements that close meanwhile are held. Release it when the cause is resolved.",
      "confirm": "Hold payouts",
      "failed": "Couldn't open the hold.",
      "done": "Payouts held for cause."
    },
    "release": {
      "action": "Release…",
      "title": "Release the {{kind}} hold on {{name}}'s payouts?",
      "words": "Payouts the hold was stopping can run again at the next payout.",
      "confirm": "Release hold",
      "failed": "Couldn't release the hold.",
      "opsOnly": "This hold can only be released by operations; it's queued.",
      "notReleasable": "This hold can't be released here: a review over the transfer cap is released by operations, and a tax ID hold clears itself once the tax ID is verified.",
      "done": "Hold released."
    },
    "void": {
      "action": "Void…",
      "title": "Void {{name}}'s balance?",
      "words": "The partner's positive balance is voided and will not be paid. Lines already paid are not touched. This can't be undone. The hold stays open until you release it.",
      "typeName": "Type {{name}} to confirm",
      "confirm": "Void balance",
      "mismatch": "The name doesn't match. Type the partner's name as shown.",
      "failed": "Couldn't void the balance.",
      "done": "Balance voided."
    },
    "payment": {
      "action": "Record a manual payment…",
      "title": "Record a manual payment to {{name}}",
      "words": "Record a payment made outside pay-api. The statement is marked paid externally.",
      "statement": "Statement",
      "reference": "For reference: closing",
      "balance": "balance",
      "paidOn": "Paid on",
      "paidOnRequired": "Enter the date it was paid.",
      "referenceLabel": "Payment reference",
      "referenceRequired": "Enter the payment reference.",
      "payableIs": "The payable amount on this statement is {{amount}}.",
      "notPayable": "This amount can't be paid on this statement. It can be at most the latest closing or the balance, whichever is lower.",
      "confirm": "Record payment",
      "failed": "Couldn't record the payment.",
      "done": "Manual payment recorded."
    },
    "adjustment": {
      "action": "Post an adjustment…",
      "title": "Post an adjustment for {{name}}",
      "words": "An adjustment corrects the partner's balance. It replaces waiving a charge and marking one collected.",
      "direction": "Direction",
      "credit": "Credit the partner (adds to their balance)",
      "charge": "Charge the partner (takes from their balance)",
      "directionRequired": "Choose credit or charge.",
      "continue": "Continue",
      "back": "Back",
      "confirmCreditTitle": "Credit {{name}} {{amount}}?",
      "confirmChargeTitle": "Charge {{name}} {{amount}}?",
      "confirmCreditWords": "This adds {{amount}} to {{name}}'s balance. It's posted as an adjustment and audited.",
      "confirmChargeWords": "This takes {{amount}} from {{name}}'s balance. It's posted as an adjustment and audited.",
      "post": "Post adjustment",
      "failed": "Couldn't post the adjustment.",
      "done": "Adjustment posted."
    },
    "frozen": {
      "banner": "This is history from before the partner ledger.",
      "link": "Use the partner's Ledger.",
      "open": "Open the Ledger"
    },
    "cutover": {
      "title": "Ledger cut-over",
      "notAvailable": "The ledger cut-over isn't available yet.",
      "loadError": "Couldn't load the cut-over readiness.",
      "mode": "Ledger mode: {{mode}}",
      "modeHelp": "Going LIVE is the Operator's environment change on both tmm-api wars.",
      "readiness": "Readiness",
      "passed": "Passed",
      "failing": "Failing",
      "failures": "Not ready: {{names}}",
      "refused": "Not yet: the readiness above says what is missing.",
      "outbox": "Pending outbox rows: {{periods}}",
      "outboxNone": "No pending outbox rows.",
      "check": {
        "A2_CONFIRMED": "pay-api A2 confirmed live in production",
        "OLD_STATEMENTS_SETTLED": "The last old statement run and paid",
        "PAYEES_READY": "Every partner set up as a payee",
        "OPENING_COMPUTED": "Opening adjustments computed",
        "DEACTIVATION_WINDOWS_RESOLVED": "Deactivation windows resolved"
      },
      "checkHint": {
        "DEACTIVATION_WINDOWS_RESOLVED": "Ledger rows inside a reseller's deactivation window have been rebuilt."
      },
      "notReadyYet": "Not ready yet:",
      "failureKind": {
        "REFUND_OF_COVERED_SALE": "A refund of a sale the opening already counts.",
        "CLAWBACK": "A commission clawback.",
        "RECOVERY": "A recovery.",
        "UNPOSTED_PAYMENT": "A payment not posted yet.",
        "UNPOSTED_COMMISSION": "A commission not posted yet.",
        "UNPOSTED_SHORTFALL": "A minimum shortfall not posted yet.",
        "NETTING_ADDON": "A netted add-on.",
        "SENT_BEFORE": "Sent before the cut-over.",
        "MISMATCH": "The reconciliation doesn't match.",
        "NO_PAYEE": "No payee is set up for this partner.",
        "OTHER_CURRENCY": "A line in another currency.",
        "TENANT_WITHOUT_RESELLER": "This partner's tenant has no reseller yet. Fix the tenant, then run the preview again."
      },
      "openingFailures": {
        "intro": "For each row, post an adjustment for that partner, then run the preview again.",
        "table": "Opening check failures",
        "col": {
          "partner": "Partner",
          "what": "What",
          "source": "Source",
          "amount": "Amount"
        }
      },
      "a2": {
        "action": "Confirm pay-api A2 is live in production…",
        "title": "Confirm pay-api A2 is live in production?",
        "words": "Confirm only once you've checked that pay-api's A2 release is live in production. It's audited.",
        "confirm": "Confirm A2",
        "failed": "Couldn't record the confirmation.",
        "done": "pay-api A2 confirmed.",
        "recorded": "pay-api A2 confirmed {{when}}"
      },
      "freeze": {
        "action": "Freeze tmm's payout machinery…",
        "title": "Freeze tmm's payout machinery?",
        "words": "Transfers, the payout close and run, and deficit and shortfall charging stop, with their retries. Nothing is deleted. Running it again changes nothing.",
        "confirm": "Freeze payouts",
        "failed": "Couldn't freeze the payout machinery.",
        "done": "Payout machinery frozen.",
        "recorded": "Payout machinery frozen {{when}}"
      },
      "verticals": {
        "action": "Confirm tmm-api is in pay-api's live verticals…",
        "title": "Confirm tmm-api is in pay-api's live verticals?",
        "words": "Confirm only once tmm-api is in PAYAPI_SETTLEMENT_LIVE_VERTICALS on both pay-api wars. tmm-api can't read that setting. It's audited.",
        "confirm": "Confirm live verticals",
        "failed": "Couldn't record the confirmation.",
        "done": "Live verticals confirmed.",
        "recorded": "Live verticals confirmed {{when}}"
      },
      "opening": {
        "title": "Opening adjustments",
        "help": "Each partner's opening is the balance carried on tmm's last paid statement. Preview it first; nothing is posted until you post it.",
        "preview": "Preview",
        "previewFailed": "Couldn't preview the opening adjustments.",
        "post": "Post opening adjustments…",
        "confirmTitle": "Post the opening adjustments?",
        "confirmWords": "One opening adjustment is posted for each partner, at the figure tmm-api computes when you post; the preview shows those figures as of now. It's audited and posted once.",
        "confirm": "Post adjustments",
        "failed": "Couldn't post the opening adjustments.",
        "done": "Opening adjustments posted.",
        "recorded": "Opening adjustments posted {{when}}",
        "posted": "Posted.",
        "dryRun": "Preview only: nothing has been posted.",
        "none": "No partner has an opening figure.",
        "matches": "Reconciles",
        "mismatch": "Doesn't reconcile",
        "col": {
          "partner": "Partner",
          "figure": "Opening",
          "reconciliation": "Reconciliation",
          "expected": "Old system",
          "ledger": "Ledger"
        }
      }
    }
  },
  "tickets": {
    "subtitle": "Support cases, feature requests and announcements for every tenant's members.",
    "tabsAria": "Support sections",
    "tab": {
      "support": "Support cases",
      "features": "Feature requests",
      "announcements": "Announcements"
    },
    "filter": {
      "search": "Search tickets",
      "searchHint": "Searches the title and description",
      "status": "Status",
      "allStatuses": "All statuses",
      "tenant": "Tenant",
      "allTenants": "All tenants",
      "created": "Created"
    },
    "created": {
      "ANY": "Any time",
      "LAST_7_DAYS": "Last 7 days",
      "LAST_30_DAYS": "Last 30 days",
      "LAST_90_DAYS": "Last 90 days"
    },
    "loadError": "Could not load tickets.",
    "empty": {
      "support": "No support cases.",
      "features": "No feature requests."
    },
    "regionAria": "Tickets list",
    "col": {
      "number": "Number",
      "title": "Title",
      "tenant": "Tenant",
      "requester": "Requester",
      "status": "Status",
      "followers": "Followers",
      "created": "Created",
      "updated": "Updated"
    },
    "status": {
      "OPEN": "Open",
      "IN_PROGRESS": "In progress",
      "WAITING_ON_YOU": "Waiting on the member",
      "RESOLVED": "Resolved",
      "CLOSED": "Closed",
      "SUBMITTED": "Submitted",
      "UNDER_REVIEW": "Under review",
      "PLANNED": "Planned",
      "SHIPPED": "Shipped",
      "NOT_PLANNED": "Not planned",
      "DUPLICATE": "Duplicate"
    },
    "type": {
      "SUPPORT_CASE": "Support case",
      "FEATURE_REQUEST": "Feature request"
    },
    "notAvailable": "Tickets aren't available yet.",
    "notFound": "This ticket doesn't exist.",
    "ticket": "Ticket",
    "ticketLoadError": "Could not load this ticket.",
    "internalNote": "Internal note: the member never sees this.",
    "composer": {
      "title": "Add to the conversation",
      "visibility": "Who sees it",
      "internal": "Internal note",
      "public": "Reply to the member",
      "publicWarning": "The member is emailed this reply.",
      "noteLabel": "Note",
      "replyLabel": "Reply",
      "counter": "{{used, number}} of {{max, number}} characters",
      "required": "Write something to post.",
      "tooLong": "At most {{max, number}} characters.",
      "postNote": "Post internal note",
      "postReply": "Post reply to the member",
      "error": "Couldn't post it."
    },
    "changeStatus": {
      "action": "Change status…",
      "title": "Change the status of {{ticket}}",
      "current": "Now: {{status}}",
      "new": "New status",
      "required": "Choose a status.",
      "emailed": "The member is emailed about this change.",
      "confirm": "Change status",
      "conflict": "That status can't follow {{status}}.",
      "error": "Couldn't change the status."
    },
    "duplicate": {
      "action": "Mark as duplicate…",
      "title": "Mark {{ticket}} as a duplicate",
      "canonical": "Duplicate of",
      "hint": "Search by number or title",
      "noOptions": "No matching tickets",
      "required": "Choose the ticket it duplicates.",
      "consequence": "{{ticket}} will point to {{canonical}}; its requester follows that ticket.",
      "confirm": "Mark as duplicate",
      "error": "Couldn't mark it as a duplicate."
    },
    "shippedIn": {
      "action": "Set \"shipped in\"…",
      "title": "Set \"shipped in\" for {{ticket}}",
      "label": "Shipped in",
      "hint": "A release or version, as free text. Leave empty to clear it.",
      "confirm": "Save",
      "error": "Couldn't save \"shipped in\"."
    },
    "page": {
      "tabsAria": "Ticket sections",
      "conversation": "Conversation",
      "details": "Details"
    },
    "meta": {
      "requester": "Asked by {{person}}",
      "created": "Created {{when}}",
      "updated": "Updated {{when}}",
      "followers_one": "{{count, number}} follower",
      "followers_other": "{{count, number}} followers",
      "shippedIn": "Shipped in {{shippedIn}}",
      "duplicateOf": "Duplicate of"
    },
    "conversation": {
      "empty": "No updates yet.",
      "statusChanged": "Status changed to {{status}}",
      "public": "Public: the member sees this"
    },
    "author": {
      "MEMBER": "Member",
      "STAFF": "Staff",
      "SYSTEM": "System"
    },
    "details": {
      "title": "Details",
      "description": "Description",
      "type": "Type",
      "email": "Email",
      "origin": "Origin",
      "drafted": "Drafted with the assistant"
    },
    "attachments": {
      "title": "Attachments",
      "onUpdate": "Attached files",
      "meta": "{{type}} · {{size}}",
      "download": "Download",
      "downloadAria": "Download {{name}}",
      "hint": "Files are only downloaded, never opened here.",
      "gone": "This file is no longer available.",
      "error": "Couldn't download this file."
    }
  },
  "announcements": {
    "notAvailable": "Announcements aren't available yet.",
    "notFound": "This announcement doesn't exist.",
    "loadError": "Could not load announcements.",
    "itemLoadError": "Could not load this announcement.",
    "new": "New announcement",
    "empty": "No announcements yet.",
    "emptyFiltered": "No announcements match these filters.",
    "regionAria": "Announcements list",
    "filter": {
      "state": "State",
      "allStates": "All states",
      "kind": "Kind",
      "allKinds": "All kinds"
    },
    "col": {
      "title": "Title",
      "kind": "Kind",
      "audience": "Audience",
      "state": "State",
      "publishAt": "Publishes",
      "expiresAt": "Expires",
      "shownAs": "Shown as",
      "related": "Related ticket",
      "reads": "Reads"
    },
    "audienceAll": "All customers",
    "audienceTenants_one": "{{count, number}} tenant",
    "audienceTenants_other": "{{count, number}} tenants",
    "pinned": "Pinned",
    "popup": "Pop-up",
    "kind": {
      "NEWS": "News",
      "FEATURE": "New feature",
      "MAINTENANCE": "Maintenance",
      "IMPORTANT": "Important"
    },
    "state": {
      "DRAFT": "Draft",
      "SCHEDULED": "Scheduled",
      "PUBLISHED": "Published",
      "EXPIRED": "Expired"
    },
    "editor": {
      "sectionContent": "Content",
      "sectionAudience": "Audience and timing",
      "sectionDisplay": "Display",
      "title": "Title",
      "titleRequired": "Enter a title.",
      "body": "Body",
      "bodyRequired": "Write the announcement.",
      "bodyHint": "Markdown: # headings, **bold**, *italic*, lists and [links](https://…). {productName} becomes each customer's product name.",
      "bodyView": "Body view",
      "edit": "Edit",
      "preview": "Preview",
      "previewEmpty": "Nothing to preview yet.",
      "previewNote": "{productName} shows as typed here; each customer sees their product's name.",
      "kind": "Kind",
      "audience": "Audience",
      "audienceChosen": "Chosen tenants",
      "tenants": "Tenants",
      "tenantsHint": "Only these tenants' members see it.",
      "tenantsRequired": "Choose at least one tenant.",
      "tenantsLoadError": "Couldn't load the tenants. Choose All customers, or try again later.",
      "publishWhen": "When to publish",
      "schedule": "Schedule",
      "publishAt": "Publish at (your time)",
      "publishAtRequired": "Choose a date and time.",
      "publishAtPast": "Choose a time in the future, or pick Now.",
      "expires": "Expires (optional, your time)",
      "expiresHint": "Leave it empty to keep it up until you expire it.",
      "expiresPast": "Choose a time in the future.",
      "expiresBeforePublish": "Choose a time after it publishes.",
      "pinned": "Pin to the top",
      "pinnedHint": "Pinned announcements are listed first.",
      "popup": "Show as a pop-up",
      "popupWarning": "Shown once, as a pop-up, to everyone in the audience on their next visit.",
      "related": "Related feature request (optional)",
      "relatedHint": "Its followers see this announcement. Search by number or title.",
      "noOptions": "No matching feature requests",
      "termRefused": "This mentions \"{{term}}\", which is internal. Remove it to publish.",
      "saveDraft": "Save draft",
      "saved": "Draft saved.",
      "saveError": "Couldn't save the draft.",
      "publishAction": "Publish…",
      "scheduleAction": "Schedule…",
      "readOnly": "Only a draft can be edited. Unpublish it first to change it.",
      "expiredReadOnly": "An expired announcement can't be changed.",
      "details": "Details",
      "author": "Written by",
      "noExpiry": "No expiry",
      "notScheduled": "Not scheduled"
    },
    "confirm": {
      "publishTitle": "Publish \"{{title}}\"?",
      "scheduleTitle": "Schedule \"{{title}}\"?",
      "whenNow": "It goes live now.",
      "whenAt": "It goes live on {{when}}.",
      "toAll": "Audience: all customers.",
      "toTenants_one": "Audience: {{count, number}} tenant ({{names}}).",
      "toTenants_other": "Audience: {{count, number}} tenants ({{names}}).",
      "popupYes": "It pops up once for everyone in the audience on their next visit.",
      "popupNo": "It doesn't pop up: members find it in their Support & features panel.",
      "expiresAt": "It expires on {{when}}.",
      "publish": "Publish",
      "schedule": "Schedule",
      "error": "Couldn't publish it.",
      "published": "Announcement published.",
      "scheduled": "Announcement scheduled."
    },
    "delete": {
      "action": "Delete draft…",
      "title": "Delete the draft \"{{title}}\"?",
      "consequence": "The draft is deleted. This can't be undone.",
      "confirm": "Delete draft",
      "done": "Draft deleted.",
      "error": "Couldn't delete the draft."
    },
    "unpublish": {
      "action": "Unpublish…",
      "title": "Unpublish \"{{title}}\"?",
      "consequence": "Members stop seeing it, and it goes back to a draft you can edit.",
      "confirm": "Unpublish",
      "done": "Announcement unpublished.",
      "error": "Couldn't unpublish it."
    },
    "expire": {
      "action": "Expire now…",
      "title": "Expire \"{{title}}\" now?",
      "consequence": "Members stop seeing it. It stays on this list as expired.",
      "confirm": "Expire now",
      "done": "Announcement expired.",
      "error": "Couldn't expire it.",
      "notPublished": "Only a published announcement can be expired. {{stateWords}}",
      "nowState": {
        "DRAFT": "This one is a draft.",
        "SCHEDULED": "This one is scheduled.",
        "PUBLISHED": "This one is published.",
        "EXPIRED": "This one has already expired."
      }
    }
  },
  "knowledge": {
    "subtitle": "Merchant names and banks learned from members, shared only when you approve them.",
    "tabsAria": "Merchant knowledge sections",
    "tab": {
      "patterns": "Merchant patterns",
      "banks": "Unlisted banks"
    },
    "notAvailable": {
      "patterns": "Merchant patterns aren't available yet.",
      "banks": "Unlisted banks aren't available yet.",
      "naming": "Naming quality isn't available yet."
    },
    "gate": {
      "NOT_P2P": "Not a person-to-person payment",
      "MOSTLY_BUSINESS": "Mostly confirmed as a business",
      "MERCHANT_MARKERS": "Merchant markers",
      "NOT_PERSONAL_NAME": "Not a personal name",
      "THRESHOLD": "Threshold met",
      "REDACTED": "Redacted"
    },
    "gateResult": {
      "passed": "Passed",
      "notPassed": "Not passed"
    },
    "gatesTally": "{{passed, number}} of {{total, number}}",
    "noProposedName": "No name proposed",
    "stateNow": {
      "CANDIDATE": "This pattern is a candidate now, so that can't be done.",
      "APPROVED": "This pattern is approved now, so that can't be done.",
      "RETIRED": "This pattern is retired now, so that can't be done."
    },
    "kind": {
      "VENDOR": "Business",
      "OTHER": "Other",
      "PERSON": "Person"
    },
    "institutionKind": {
      "BANK": "Bank",
      "CREDIT_UNION": "Credit union",
      "OTHER": "Other"
    },
    "source": {
      "KNOWN_MERCHANT": "Known merchants",
      "BANK_TEXT": "Bank text",
      "AI": "AI"
    },
    "view": {
      "aria": "Merchant pattern queues",
      "ready": "Ready for review",
      "short": "Still short",
      "approved": "Approved",
      "retired": "Retired"
    },
    "search": "Search patterns",
    "searchHint": "Searches the pattern and the proposed name",
    "loadError": "Could not load the merchant patterns.",
    "regionAria": "Merchant patterns list",
    "empty": {
      "ready": "No candidates are ready for review.",
      "short": "No candidates are still short.",
      "approved": "No approved patterns.",
      "retired": "No retired patterns."
    },
    "col": {
      "pattern": "Pattern",
      "proposedName": "Proposed name",
      "kind": "Kind",
      "confirmations": "Confirmations",
      "edits": "Edits",
      "forgets": "Forgets",
      "members": "Members",
      "tenants": "Tenants",
      "gates": "Gates passed",
      "actions": "Actions"
    },
    "detail": {
      "open": "Open",
      "pattern": "Pattern",
      "kind": "Kind",
      "evidence": "Evidence",
      "gates": "Gates",
      "noGates": "No gate results were sent."
    },
    "approve": {
      "open": "Approve…",
      "title": "Approve a merchant pattern",
      "name": "Name",
      "nameHint": "Correct the spelling if needed.",
      "nameRequired": "Enter a name.",
      "kind": "Kind",
      "kindRequired": "Choose a kind.",
      "consequence": "Members whose bank text matches this pattern will see it named “{{name}}” ({{kind}}).",
      "error": "Couldn't approve the pattern.",
      "notPromotable": "This pattern can't be approved yet. It doesn't pass: {{gates}}.",
      "confirm": "Approve",
      "done": "Pattern approved."
    },
    "reject": {
      "open": "Reject…",
      "title": "Reject “{{name}}”",
      "reason": "Reason",
      "hint": "Kept with the audit record. Members never see it. {{used, number}} of {{max, number}} characters.",
      "required": "Enter a reason.",
      "tooLong": "Use {{max, number}} characters or fewer.",
      "error": "Couldn't reject the pattern.",
      "confirm": "Reject",
      "done": "Pattern rejected."
    },
    "retire": {
      "open": "Retire…",
      "title": "Retire “{{name}}”?",
      "consequence": "Members' naming stops using this pattern, and it moves to Retired.",
      "confirm": "Retire",
      "error": "Couldn't retire the pattern.",
      "done": "Pattern retired."
    },
    "banks": {
      "loadError": "Could not load the unlisted banks.",
      "empty": "No unlisted banks to review.",
      "regionAria": "Unlisted banks list",
      "newest": "Showing the {{max, number}} newest.",
      "requests_one": "{{count, number}} request",
      "requests_other": "{{count, number}} requests",
      "col": {
        "typedName": "Typed name",
        "country": "Country",
        "count": "Requests",
        "requestedAt": "Last requested"
      },
      "add": {
        "open": "Add to catalog…",
        "title": "Add “{{name}}” to the catalog",
        "name": "Name",
        "nameHint": "As members should see it.",
        "nameRequired": "Enter a name.",
        "country": "Country",
        "countryInvalid": "Enter the two-letter country code, such as CR or US.",
        "city": "City (optional)",
        "kind": "Kind",
        "kindRequired": "Choose a kind.",
        "error": "Couldn't add the bank to the catalog.",
        "confirm": "Add to catalog",
        "done": "{{name}} added to the catalog.",
        "exists": "Already listed. A bank with this name is already in the catalog for {{country}}. Dismiss this request instead.",
        "dismissInstead": "Dismiss request"
      },
      "dismiss": {
        "open": "Dismiss…",
        "title": "Dismiss “{{name}}”?",
        "consequence_one": "The request from {{country}} is closed. Nothing is added to the catalog.",
        "consequence_other": "The {{count, number}} requests from {{country}} are closed. Nothing is added to the catalog.",
        "confirm": "Dismiss",
        "error": "Couldn't dismiss the request.",
        "done": "Request dismissed."
      }
    }
  },
  "namingQuality": {
    "intro": "Is naming getting better? How often members accept, edit or forget the names they are given.",
    "noInstitution": "Not matched to a catalog bank",
    "loadError": "Could not load the naming quality report.",
    "empty": "No names in this period.",
    "by": {
      "aria": "Naming quality sections",
      "source": "By naming source",
      "institution": "By institution",
      "model": "By model and prompt version"
    },
    "col": {
      "source": "Naming source",
      "institution": "Institution",
      "model": "Model",
      "promptVersion": "Prompt version",
      "named": "Names",
      "accepted": "Accepted",
      "edited": "Edited",
      "forgotten": "Forgotten",
      "acceptanceRate": "Acceptance rate",
      "editRate": "Edit rate",
      "forgetRate": "Forget rate"
    }
  }
}
